const en = {
  common: {
    datePicker: {
      calendar: 'Calendar',
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      pageIndicator: 'Page {currentPage} of {totalPages}',
    },
    buyerPlusImgAlt: 'BuyerPlus',
    mieterPlusImgAlt: 'TenantPlus',
    branding: {
      living: 'Wohnen',
      search: 'Suchen',
      searchForRenting: 'for rent',
      searchForBuying: 'for buy',
    },
    labels: {
      mandatoryField: 'Required *',
      success: 'Success',
      delete: 'Delete',
      cancel: 'Cancel',
      error: 'Error',
      errorMessage: 'An unknown error occurred. Please try again later',
    },
    buttons: {
      save: 'Save',
      close: 'Close',
      previous: 'Back',
      next: 'Next',
      backToOverview: 'Back to Overview',
      discoverWohnenPlus: 'Discover Wohnen+',
      upgradeWohnenPlus: 'Upgrade now',
      callNow: 'Call now',
    },
    tenantBenefitModal: {
      active: 'ACTIVE',
      benefit: 'Your benefit',
      advice: 'Your advice',
      protection: 'Your protection',
      support: 'Your support',
      howItWorks: 'How it works',
      membership: 'Your membership',
      customerNumber: 'Customer number',
      insuranceNumber: 'Insurance number',
      address: 'Address',
      changeAddress: 'Change address',
      goodToKnow: 'Good to know',
      availabilityError: {
        title: 'Benefits currently unavailable',
        message: 'We could not load the availability of your benefits. Please try again.',
        retry: 'Try again',
      },
      magentaTv: {
        headline: 'Watch TV and stream anywhere with MagentaTV Flex — now with a 15% discount*',
        description: 'Stream television, films and series flexibly on all your devices. Cancel monthly.',
        disclaimer: '* Terms of use apply.',
        cta: 'Get 15% discount',
        features: {
          1: 'More than 160 HD channels',
          2: 'Films and series on MagentaTV+ included',
          3: 'Restart, timeshift and recording',
          4: 'Add streaming services such as Netflix or Disney+',
        },
        steps: {
          1: { title: 'Get voucher', description: 'Create your personal voucher code' },
          2: {
            title: 'Book MagentaTV Flex',
            description: 'Redeem the voucher when booking MagentaTV Flex',
          },
          3: {
            title: 'Use discount',
            description: 'Stream for €8.50 per month and cancel flexibly at the end of the month',
          },
        },
        info: {
          1: 'The voucher is for new MagentaTV customers',
          2: 'The offer cannot be combined with other promotions or vouchers',
          3: 'MagentaTV One is optionally available for €5 per month',
        },
      },
      greenElectricity: {
        headline: 'Exclusive Wohnen+ discount: no service fee for the first 12 months',
        description:
          'Switch to a dynamic green electricity tariff and benefit when exchange prices are particularly low.',
        features: {
          1: 'Exclusive Wohnen+ discount',
          2: 'Save up to 40% with dynamic exchange prices',
          3: 'No service fee for 12 months (instead of €4.99 per month)',
          4: 'Green electricity with flexible pricing',
        },
        steps: {
          1: { title: 'Enter consumption', description: 'Enter your current electricity consumption and address' },
          2: {
            title: 'Review offer',
            description: 'Receive a personal tariff overview with your potential savings',
          },
          3: {
            title: 'Switch tariff',
            description: 'Complete the tariff and KlarWatt handles the next steps',
          },
        },
      },
      storage: {
        headline: 'Rent additional space with a storage unit from LAGERBOX.',
        description: 'Rent additional storage from LAGERBOX and receive exclusive Wohnen+ member discounts.',
        features: {
          1: '5% discount on the Basic package',
          2: '15% discount on the Premium package',
          3: 'Flexible storage sizes',
          4: 'Exclusive benefit for Wohnen+ members',
        },
        steps: {
          1: { title: 'Request an offer', description: 'Complete the application form' },
          2: {
            title: 'Find suitable storage',
            description: 'LAGERBOX sends available options near you',
          },
          3: { title: 'Get your discount', description: 'Choose your package and use your Wohnen+ discount' },
        },
      },
      addressChange: {
        headline: 'Digital address change',
        description: 'Notify relevant recipients quickly and securely about your new address.',
        states: {
          START_PREMIUM: {
            paragraph1: 'Start digital address change',
            paragraph2:
              "You're moving soon? We recognize & notify all relevant recipients about your change of address.",
            ctaText: 'Start address change',
          },
          CONTINUE: {
            paragraph1: 'Continue digital address change',
            paragraph2: 'You already have an address change in progress. Complete your address change now.',
            ctaText: 'Complete address change',
          },
          NOT_ELIGIBLE_USED_MP: {
            paragraph1: 'Change of address from Suchen+ for rent 12 already used',
            paragraph2:
              'You have already used your included change of address. You can purchase further changes of address individually.',
            ctaText: 'Buy address change',
          },
          NOT_ELIGIBLE: {
            paragraph1: 'The digital change of address is not included in your membership',
            paragraph2:
              'Are you moving soon? We will recognize & notify all relevant recipients about your change of address. You can purchase your change of address individually.',
            ctaText: 'Buy change of address',
          },
        },
        features: {
          1: 'Notify relevant recipients centrally',
          2: 'Completely digital and paperless',
          3: 'Complete in under 5 minutes',
          4: 'Highest data security standard',
        },
        steps: {
          1: { title: 'Enter addresses', description: 'Enter your previous and new address' },
          2: {
            title: 'Select recipients',
            description: 'Select which companies and institutions should be notified',
          },
          3: {
            title: 'Complete address change',
            description: 'Review your details and send the notifications digitally',
          },
        },
      },
      billCheck: {
        headline: 'Get money back from your landlord with the utility bill quick check',
        description:
          'Many utility bills are too high. Have Mineko legal experts check your bill and get money back when errors are found.',
        features: {
          1: 'Review by Mineko legal experts',
          2: 'Submit digitally by scan or photo',
          3: 'Receive your personal review result from experts within 5 days',
          4: 'Support with incorrect bills',
        },
        steps: {
          1: { title: 'Upload bill', description: 'Upload your utility bill' },
          2: { title: 'Review', description: 'Mineko checks your bill for possible errors' },
          3: {
            title: 'Receive result',
            description: 'Receive your personal review result within 5 days',
          },
        },
        cta: { start: 'Upload bill', continue: 'Continue utility bill check' },
      },
      rechtsberatung: {
        headline: 'Do you have questions about tenancy and real estate law?',
        description:
          'For legal problems and questions concerning tenancy and real estate law, contact ARAG by phone to obtain a legally sound opinion.',
        features: {
          1: 'Up to two initial assessments per year',
          2: 'Advice from ARAG legal experts',
          3: 'Available around the clock',
          4: 'No representation in court or full legal advice',
        },
        steps: {
          1: { title: 'Call now', description: 'Contact ARAG' },
          2: { title: 'Have your contract number ready', description: 'You can find it on your insurance certificate' },
          3: { title: 'Get an opinion', description: 'A legal expert will answer your questions' },
        },
      },
      mietrechtsschutz: {
        headline: 'Rental legal protection supports you in a legal dispute',
        description:
          'If telephone advice and mediation do not resolve a conflict, rental legal protection supports the next steps.',
        features: {
          1: 'Support for tenancy-related legal disputes',
          2: 'Advice from qualified ARAG Assistance lawyers',
          3: 'Choose a €150 or €0 deductible per case',
          4: 'Included in Wohnen+ M and L',
        },
        steps: {
          1: { title: 'Activate protection', description: 'Choose and confirm your deductible' },
          2: {
            title: 'Report the conflict',
            description: 'Contact ARAG',
          },
          3: {
            title: 'Receive support',
            description: 'Your case is reviewed and you receive support with the next steps',
          },
        },
      },
      schluesseldienst: {
        headline: 'Protected in an emergency with ARAG locksmith service',
        description: 'Emergency door-opening costs of up to €500 are covered.',
        features: {
          1: 'Up to €500 covered per door-opening incident',
          2: 'Included in Wohnen+ S, M and L',
          3: 'Up to two incidents per year',
        },
        steps: {
          1: { title: 'Call now', description: 'We will connect you with our partner' },
          2: {
            title: 'Help is on its way',
            description: 'A locksmith near you will head over as soon as possible',
          },
          3: { title: 'Open on site', description: 'Identify yourself and the locksmith will open your door' },
        },
      },
      mediation: {
        headline: 'Do you need help resolving a conflict?',
        description: 'ARAG mediation supports disputes between tenants and landlords.',
        features: {
          1: 'Neutral support from experienced mediators',
          2: 'Help with conflicts concerning your tenancy',
          3: 'Joint, out-of-court conflict resolution',
          4: 'Included in Wohnen+ S, M and L',
        },
        steps: {
          1: {
            title: 'Get in touch',
            description: 'Briefly describe your conflict',
          },
          2: {
            title: 'Prepare the discussion',
            description: 'ARAG reviews your case and arranges support',
          },
          3: {
            title: 'Find a solution',
            description: 'A neutral person supports everyone involved',
          },
        },
      },
    },
    copy: 'Copy',
    copied: 'Copied',
    navigationLinks: {
      buying: 'Buying',
      renting: 'Renting',
      living: 'Living',
    },
    errorMessages: {
      inputRequired: 'Required input',
      invalidEmailFormat: 'Invalid email format',
      invalidDate: 'Invalid date',
      invalidPhoneNumber: 'Invalid phone number',
    },
    salutation: {
      female: 'Female',
      male: 'Male',
      other: 'Other',
    },
    adacModal: {
      product: '<Indicator>Wohnen</Indicator> with home protection cover',
      partnership: 'In collaboration with',
      headline: '24/7 breakdown assistance for your home',
      'discount-description': 'With Suchen+ for renting, you receive a <strong>25% welcome discount</strong>.',
      'daily-price-explanation':
        'Daily price calculation: Billing is date-based. The daily price is computed for simplicity by dividing the monthly amount by 31 days.',
      description:
        'Washing machine broken? Locked out? Or service charges too high? The essential + for breakdowns and costs around your new home.',
      benefits: {
        'emergency-locksmith-service': {
          title: 'Emergency locksmith service',
          description: 'e.g. if you are locked out',
        },
        'tradesperson-service': {
          title: 'Tradesperson service',
          description: 'e.g. a broken washing machine',
        },
        'ancillary-cost-review': {
          title: 'Service charge review',
          description: 'e.g. increased service charges',
        },
      },
      plans: {
        common: {
          selection: 'Choose a billing period',
          'daily-price': '≈ {price} / day',
          'minimum-term': '12-month minimum term',
        },
        monthly: {
          name: 'Monthly',
          'billing-period': 'Month',
        },
        yearly: {
          name: 'Yearly',
          'billing-period': 'Year',
          savings: 'Save {savings} / year',
        },
      },
      actions: {
        secondary: 'Learn more',
        primary: 'Continue to payment',
      },
    },
    aragModal: {
      statusMessage: {
        missingDetails: {
          headline: 'Missing details',
          message: 'Please enter your details in the form below',
        },
        pendingError: {
          headline: 'In progress',
          message: 'Your request is being processed. Please wait a moment.',
        },
        updateDetailsError: {
          headline: 'Unfortunately, that did not work',
          message: 'A technical error occurred. Please try making the change again later.',
        },
      },
      aragDetails: {
        image: 'ARAG Logo',
        companyName: 'ARAG SE',
        addressLine1: 'ARAG-Platz 1',
        addressLine2: '40472 Düsseldorf',
      },
      insuranceDetails: {
        customerNumber: 'Your customer number:',
        address: 'Your address',
        contact: {
          key: 'Emergency contact details',
          phoneNumber: {
            mietrechtsschutz: '0211 98901886',
            mediation: '0211 98901886',
            rechtsberatung: '0211 9933399',
            schluesseldienst: '0211 98901405',
          },
          availability: 'Available around the clock every day',
          eMail: 'service@arag.de',
        },
        documents: {
          key: 'Documents',
          certificate: 'Insurance certificate',
          conditions: 'Insurance terms and conditions',
          link: {
            s: 'https://www.arag-kooperationen.de/wps',
            m: 'https://www.arag-kooperationen.de/wpm',
            l: 'https://www.arag-kooperationen.de/wpl',
          },
        },
      },
      form: {
        customerNumber: 'Your customer number',
        policyNumber: 'Your policy number',
        address: 'Your address',
        edit: 'edit',

        saveButtonText: 'Save',
        cancelButtonText: 'Cancel',
        city: {
          label: 'City',
          placeholder: '',
        },
        salutation: {
          label: 'Salutation',
          options: {
            female: 'Ms',
            male: 'Mr.',
            neutral: 'Other',
          },
        },
        firstName: {
          label: 'First name',
          placeholder: '',
        },
        lastName: {
          label: 'Last name',
          placeholder: '',
        },
        street: {
          label: 'Street',
          placeholder: '',
        },
        houseNumber: {
          label: 'House number',
          placeholder: '',
        },
        postcode: {
          label: 'Postal code',
          placeholder: '',
        },
      },
    },
  },
  issuePage: {
    headline: 'Something went wrong',
    unknown: {
      illustration: 'Unfortunate power outlet',
      message:
        'It might have been due to a poor internet connection or temporary technical overload. Please try again later.{br}{br}Thank you for your understanding!',
      link: 'Retry',
    },
    not_found: {
      illustration: 'Magnifying glass as illustration',
      message:
        'Please check the spelling of the internet address (capitalization) and/or the freshness of your bookmark.{br}{br}Thank you for your understanding!',
      link: 'Back',
    },
    benefit_page_error: {
      illustration: 'Magnifying glass as illustration',
      message: 'This service is currently unavailable, we are working on a solution. Please try again later.',
      link: 'Back',
    },
  },
  headArea: {
    headline: 'My',
    plus: 'Plus',
  },
  benefitsFilters: {
    headline: 'My',
    headline2: {
      buying: 'Benefits for buying',
      renting: 'Benefits for renting',
      living: 'Benefits',
    },
    filters: {
      search: 'Search',
      buy: 'Buy',
      living: 'Live',
    },
    errorMessage:
      'Some of the {benefit} services are not working, we are working on a solution. Thank you for your patience',
  },
  benefitCardStatus: {
    adac: { activate: 'Activate now' },
    lightOnly: 'full version only',
    common: {
      activated: 'Activated',
      notActivated: 'Activation Required',
    },
    deposit: {
      activated: 'Activated',
      rejected: 'Rejected',
      pending: 'Under Review',
      notActivated: 'Activation Required',
      cancelled: 'Cancelled',
      amountReduced: 'Deposit Amount Reduced',
    },
    schufa: {
      stored: 'Stored',
      expired: 'Expired',
    },
    billcheck: {
      actionRequired: 'Action Required',
      done: 'Completed',
      pending: 'Under Review',
    },
    insurance: {
      pending: 'Activation pending',
    },
  },
  documents: {
    landlord: {
      propertyLabel: 'Property',
      availabilityLabel: 'Available',
      manageCta: 'Manage',
    },
    item: {
      rentalContractCancelMessage: 'Our termination template makes it easy for you to end your rental agreement.',
      rentalContractCancelButton: 'Draft a termination',
      cancelationModalTitle: 'Terminate my rental agreement',
      cancelationModalContentTitle: 'Do you want to terminate your rental agreement soon?',
      cancelationModalContentText:
        'Customize this template with just a few clicks and send out your termination letter right away.',
      cancelationModalContentTextCheck1: 'Legally compliant termination',
      cancelationModalContentTextCheck2: 'Available for immediate download',
      cancelationModalContentTextCheck3: 'Ready to be sent',
    },
    edit: {
      modalTitle: 'Edit document',
      form: {
        nameLabel: 'File name',
        nameRequired: 'Please enter a file name',
        typeLabel: 'Category',
        typeRequired: 'Please choose a category',
        successEditMessage: 'Document has been successfully edited',
      },
      delete: {
        modalTitle: 'Delete document',
        modalText: 'Do you really want to delete this document?',
      },
    },
    errors: {
      uploadError: 'The document could not be uploaded.',
      deleteError: 'The document could not be deleted.',
      editError: 'The document could not be edited.',
    },
    type: {
      RENTAL_CONTRACT: 'Rental contract',
      RENTAL_DEPOSIT: 'Rental deposit',
      HANDOVER_PROTOCOL: 'Handover protocol',
      UTILITY_COSTS: 'Utility bill',
      FLOOR_PLAN: 'Floor plan',
      INTERNET: 'Internet',
      TERMINATION: 'Termination',
      RENT_INCREASE: 'Rent increase',
      ELECTRICITY_BILL: 'Electricity bill',
      OTHER: 'Other document',
    },
    tile: {
      title: 'Documents',
      subtitle: 'All your important rental documents in one place.',
      uploadCta: 'Add document',
      actionsMenuLabel: 'Document actions',
      actions: {
        preview: 'View',
        edit: 'Edit',
        download: 'Download',
        delete: 'Delete',
      },
      emptyState: {
        title: 'Start your digital document folder',
        description:
          'As soon as documents are provided or uploaded, you will find them here safely and clearly in one place.',
        cta: 'Upload first document',
      },
      errorState: {
        title: 'Documents could not be loaded',
        description: 'Please try again.',
        retry: 'Try again',
      },
    },
  },
  benefits: {
    adac: {
      headline: 'ADAC home protection',
      pending: {
        title: 'Your details have been saved',
        description: 'Your ADAC home protection will be activated within 1–2 working days.',
        emailNotice: 'We will notify you by email as soon as your cover starts.',
      },
      form: {
        description: 'To use ADAC home protection, we need your address.',
        firstName: 'First name',
        lastName: 'Last name',
        street: 'Street',
        suggestionsUnavailable: 'Address suggestions are currently unavailable. Please enter your address manually.',
        houseNumber: 'House no.',
        postalCode: 'Postcode',
        invalidPostalCode: 'Invalid postcode',
        city: 'City',
        birthDate: 'Date of birth',
        minimumAge: 'You must be at least 18 years old.',
        invalidAddress: 'The address is invalid. Please check the street, house number, postcode and city.',
        unsupportedCountry: 'ADAC home protection is only available for addresses in Germany.',
        addressValidationUnavailable: 'Your address cannot be checked right now. Please try again later.',
        accountDataUnavailable: 'Your account details cannot be loaded right now. Please try again later.',
        storageUnavailable: 'Your application cannot be saved right now. Please try again later.',
        applicationAlreadyExists: 'An application already exists. Please contact customer service.',
        invalidInput: 'The application details are invalid. Please check your details and date of birth.',
        submissionFailed:
          'We could not confirm your application. Please try again. Before sending it again, we will check whether your application has already been saved.',
        privacyTitle: 'Privacy notice for ADAC home protection',
        privacyDescription:
          'When you click “Save”, we transmit your application data – first and last name, street and house number, postcode and city, date of birth and your email address – to ADAC Zuhause Versicherung AG, Hansastraße 19, 80686 Munich. ADAC needs this information to review your application and, if accepted, set up your insurance cover. Insurance cover cannot be provided without the required information. The data is processed to take steps prior to entering into a contract and – if a contract is concluded – to perform the insurance contract (Art. 6(1)(b) GDPR). You can find further information in the <privacyLink>ADAC privacy information</privacyLink>.',
      },
      modal: {
        image: 'Leaking washing machine with water and foam on the floor',
        activate: 'Activate home protection',
        headline: 'What ADAC home protection offers:',
        description:
          'Locked out? Blocked pipe? Heating broken? ADAC home protection quickly arranges suitable help when something goes wrong at home!',
        sections: {
          coverage500: 'Service arrangements and reimbursement of up to 500 euros per insured event',
          coverage150: 'Reimbursement of up to 150 euros for one claim per insurance year',
          other: 'Further services',
        },
        services: {
          locksmith: 'Emergency locksmith service',
          pestControl: 'Pest control',
          waspRemoval: 'Removal of wasp and hornet nests',
          childAndPetCare: 'Childcare and pet accommodation in an emergency',
          electricalEmergency: 'Emergency electrical service',
          pipeCleaning: 'Drain cleaning service',
          heatingAndPlumbing: 'Emergency heating and plumbing service',
          householdHelp: 'Household help in an emergency',
          accommodation: 'Accommodation following an emergency',
          applianceRepair: 'Repair of large household appliances',
          burglary: 'Emergency services following a burglary',
          floorRepair: 'Repair of minor floor damage',
          legalAdvice: 'Initial legal advice on housing and construction',
          tradespersonReferral: 'Tradesperson referrals for minor damage',
          serviceProviderReferral: 'Referrals for drain cleaning, heating and plumbing services',
        },
      },
      activationNotification: {
        title: 'Your insurance cover is not yet activated.',
        message: 'Please provide your address and further information.',
      },
    },
    wohnenPlusSection: {
      title: 'Exclusive protection and more services for your home',
      subtitle: 'As a {WohnenPlusLogo} member, protect yourself and live with greater peace of mind.',
      benefitsTitle: 'My {WohnenPlusLogo} benefits',
      categories: {
        label: 'Wohnen+ categories',
        protection: 'Protect yourself',
        emergencies: 'Emergencies',
        savings: 'Save money',
        everyday: 'Utility costs',
      },
      tags: {
        arag: 'ARAG',
        twicePerYear: 'up to twice a year',
        mediationTwicePerYear: 'twice a year',
        storageTwicePerYear: 'twice a year',
        rentalLegalProtectionTwicePerYear: 'twice a year',
        locksmithTwicePerYear: 'twice a year',
        aroundTheClock: '24/7',
        billCheckTwicePerYear: 'twice a year',
        magentaTvTwicePerYear: 'twice a year',
        magentaTvDiscount: 'up to 15% discount',
        legalAdviceTwicePerYear: 'twice a year',
        germanyWide: 'Available throughout Germany',
        klarWattNoServiceFee: 'up to 12 months without service fee',
        storageDiscount: 'up to 15% discount',
        oncePerYear: 'once a year',
        mineko: 'MINEKO',
      },
      tile: {
        available: 'ACTIVE',
        locked: 'Unlock',
        loading: 'Benefit availability is loading',
        tags: 'Providers and conditions',
      },
      carousel: {
        label: 'Wohnen+ benefits',
        roledescription: 'carousel',
        slideRoledescription: 'slide',
        paginationItem: 'Benefit {currentPage} of {totalPages}',
      },
      faq: {
        title: 'Frequently asked questions about',
        suitability: {
          question: 'Who is Wohnen+ suitable for?',
          answer1:
            'Wohnen+ is for everyone who has already found their dream home. Whether you have recently moved, are planning to move soon or would prefer never to move out of your dream home: we protect your peace of mind at home. This includes an emergency locksmith service, an annual review of your utility bill, an initial consultation on tenancy law, discounted storage space and much more.',
        },
        whySubscribe: {
          question: 'Why should I subscribe to Wohnen+?',
          answer1:
            'Do you not want to spend your savings on a legal dispute with your landlord? Then Wohnen+ is just right for you!',
          answer2:
            'Are you sometimes in a hurry and pull the door shut behind you without reaching for your key? Then Wohnen+ is just right for you!',
          answer3:
            'Do you love shopping but regularly forget that your two-room apartment is slowly bursting at the seams? Then Wohnen+ is just right for you!',
          answer4:
            'Does your utility bill seem far too high, but you do not know who to ask? Then Wohnen+ is just right for you!',
          answer5:
            'Wohnen+ is designed for everyone who likes to be well protected. We are here for you and make sure you can sleep soundly – no matter what happens to your home.',
        },
        alternatives: {
          question: 'What distinguishes Wohnen+ from other alternatives, such as insurance?',
          answer1:
            'Thanks to our many years of expertise in the real-estate sector, we are number one when it comes to protecting your living experience. To achieve this, we work with strong partners from a range of fields. This means we select suitable offers for you and put together the best possible package.',
          answer2:
            'Wohnen+ protects your peace of mind at home with benefits such as an emergency locksmith service, tenancy-law advice, a review of your utility bill, discounted storage space and much more. Suchen+, on the other hand, is perfectly tailored to the period in which you are actively looking for a home. Of course, you can use both products at the same time during your search – whatever best suits your needs.',
        },
        searchAndLiving: {
          question: 'Can I have and use Suchen+ and Wohnen+ at the same time?',
          answer1:
            'Yes! Wohnen+ is your membership for every situation involving your home. Suchen+ supports you while you are actively looking for a home. Of course, you can use both products at the same time – whatever best suits your needs.',
        },
        features: {
          question: 'Where can I find my Wohnen+ features and how can I use them?',
          answer1:
            'You can find your Wohnen+ features in your account under “Mein Plus”. You can also find them in “Meine Immos” under “Mein Zuhause”. There, you can see your available Wohnen+ features and find the next steps for using them.',
        },
        availability: {
          question: 'When can I use Wohnen+?',
          answer1:
            'You can use all Wohnen+ features immediately after completing your membership, with no waiting period.',
        },
        claim: {
          question: 'What should I do in the event of a claim?',
          answer1:
            'In the event of a claim, contact the relevant partner directly. You can find the relevant information under “Mein Bereich” in the top right and then under “Mein Plus”. You can also find your Wohnen+ features in “Meine Immos” under “Mein Zuhause”.',
          answer2:
            'If you have problems or questions about our partners – or do not know what to do next – we are always here to help via “Kontakt & Hilfe”.',
        },
        provider: {
          question: 'Who is behind Wohnen+?',
          answer1:
            'ImmoScout24 works with many reliable and experienced partners. These include major insurance companies and experienced lawyers who are selected specifically for the relevant area. We select, support and optimise our partners.',
        },
        term: {
          question: 'Why are there no shorter terms?',
          answer1:
            'We protect your tenancy, and experience shows that it lasts several years. That is why we want to be there for you over a longer period. Longer terms allow us to calculate the price better and offer you an optimal value-for-money package.',
          answer2:
            'The membership is independent of your home. This means you can move anywhere within Germany at any time and remain perfectly protected.',
        },
        move: {
          question: 'What if I want to move?',
          answer1:
            'Your Wohnen+ membership is independent of where you live. This means you can move anywhere within Germany at any time and remain perfectly protected.',
        },
      },
      benefits: {
        legalAdvice: {
          title: 'Initial consultation',
          description: 'Telephone initial advice on tenancy and real estate law around the clock.',
          unlockedDescription: 'Telephone initial advice on tenancy and real estate law around the clock',
          assetAlt: 'Telephone initial consultation',
        },
        rentalLegalProtection: {
          title: 'Rental legal protection',
          description: 'Legal support when a conflict turns into a legal dispute.',
          unlockedDescription: 'Call and report a case',
          assetAlt: 'Rental legal protection',
        },
        locksmith: {
          title: 'Locksmith service',
          description: 'Quick help around the clock when you are locked out.',
          unlockedDescription: 'Contact a locksmith service',
          assetAlt: 'Locksmith service',
        },
        mediation: {
          title: 'Mediation',
          description: 'Neutral support to settle conflicts out of court.',
          unlockedDescription: 'Contact a lawyer',
          assetAlt: 'Mediation',
        },
        magentaTv: {
          title: 'MagentaTV benefit',
          description: 'Get exclusive conditions for TV and entertainment.',
          unlockedDescription: 'Redeem exclusive conditions',
          assetAlt: 'MagentaTV benefit',
        },
        greenElectricity: {
          title: 'KlarWatt green electricity',
          description: 'Find a suitable green electricity tariff and lower your energy costs.',
          unlockedDescription: 'Redeem an exclusive discount',
          assetAlt: 'KlarWatt green electricity',
        },
        storage: {
          title: 'Storage space',
          description: 'Find additional storage space near you at exclusive conditions.',
          unlockedDescription: 'Use additional storage space',
          assetAlt: 'Storage space',
        },
        addressChange: {
          title: 'Digital address change',
          description: 'Easily notify important contacts about your new address.',
          assetAlt: 'Digital address change',
        },
        billCheck: {
          title: 'Utility bill check',
          description: 'Have your utility bill checked and identify possible errors.',
          unlockedDescription: 'Have your utility bill checked',
          assetAlt: 'Utility bill check',
        },
      },
    },
    mieterNetzwerk: {
      headline: 'Tenant Network',
      modal: {
        headline: 'Tenant Network',
        image: 'Tenant Network',
        overview: {
          paragraph1: 'Discover unpublished rental listings in the Tenant Network.',
          paragraph2:
            'Become part of the Tenant Network and find out who else is looking for a new place to live and which apartments will be available soon.',
        },
        activeMieterPlus: 'Included in {Logo} for rent',
        cta: {
          ELIGIBLE: 'Join Tenant Network',
          DRAFT: 'Finalize listing',
          editImmos: "Edit under 'My Properties'",
          startSearch: 'Start searching now',
          discoverSuchenPlus: 'Discover Suchen+',
        },
        faq: {},
      },
    },
    warteliste: {
      headline: 'Waitlist',
      modal: {
        headline: 'Waitlist',
        image: 'Waitlist',
        overview: {
          paragraph1:
            'With waitlists, landlords can see your interest and contact you even before publishing a listing.',
          paragraph2:
            'The feature uses your saved search and includes currently deactivated listings. When a property becomes available again, landlords can contact you directly – without having to create a new listing.',
        },
        activeMieterPlus: 'Included in {Logo} for rent',
        linkButton: 'Discover Suchen+',
        linkButtonPlusCta: 'Adjust search criteria now',
        faq: {},
      },
    },
    magentaTv: {
      headline: 'MagentaTV benefit',
      modal: {
        image: 'Magenta TV',
        buttonCta: {
          claimVoucher: 'Get voucher',
          redeemVoucher: 'Redeem voucher',
          explore: 'Discover {product}',
        },
        voucher: {
          title: 'Your personal voucher code:',
          subtitle: 'Copy your voucher code and redeem it by December 31, 2026.',
          errorMessage: 'No voucher codes are currently available. Please try again later.',
          disclaimer: 'Note: You can only create one voucher code.',
        },
        overview: {
          headline: 'MagentaTV – unique entertainment variety, flexible like never before!',
          paragraph1:
            'Whether TV, smartphone, tablet or laptop: Experience television & streaming everywhere and anytime with MagentaTV Flex. Now for you with 15% discount*',
          bullet1: 'Wide range of channels with over 160 HD channels',
          bullet2: 'Movies and series included with MagentaTV+',
          bullet3: 'More comfort thanks to restart, timeshift and recording feature',
          bullet4: 'Streaming services such as Netflix or Disney+ can be added',
          bullet5: 'Only €8.50 monthly, can be canceled monthly, usable with any internet connection',
          starredInfo: '* Terms of use apply.',
        },
        howItWorks: {
          image1: 'Magenta TV',
          image2: 'Magenta TV',
          image3: 'Magenta TV',
          step1: "Create your voucher code via 'Get voucher'. Copy it and click on 'Redeem voucher'",
          step2:
            'You will be automatically redirected to the shopping cart. Enter your voucher code in the top right there and click "Continue".',
          step3: 'Proceed to checkout, complete the ordering process and enjoy MagentaTV',
        },
        faq: {
          item0: {
            question: 'What does MagentaTV include?',
            answer: `<ul>
            <li>Over 180 channels, more than 160 in HD</li>
            <li>Use on TV as well as on smartphone, tablet & laptop, on up to 3 devices simultaneously</li>
            <li>Determine your own broadcast time with the restart and timeshift feature, find favorite content quickly with the comprehensive search</li>
            <li>Store up to 50 hours in the cloud and stream at your desired time</li>
            <li>Additional streaming services such as Netflix or Disney+ can be added at any time</li>
            <li>Enjoy exclusive concerts and festivals such as Lollapalooza or Wacken with MagentaMusik – live or on demand</li>
            </ul>`,
          },
          item1: {
            question: 'Who can redeem the voucher for MagentaTV Flex?',
            answer:
              "The voucher is only valid for ImmoScout24 Plus members. As a Plus member, you can copy your personal voucher code via the 'Get voucher' button and use it for your order.",
          },
          item2: {
            question: 'How can I book MagentaTV independently of the internet provider and register?',
            answer:
              `<ol>
            <li>Add MagentaTV Flex to your shopping cart and enter your personal voucher code at the end of the summary.</li>
            <li>Set up a user account. You'll need an email address and a password.</li>
            <li>Provide a payment method.</li>
            <li>Place a paid order and start your TV streaming.</li>
            </ol>` +
              `<p><strong>Important:</strong> If you already have a landline and internet contract with Telekom and a Telekom login, please make sure to create a new login with a different email address in order to use the voucher code. Also, please use a different payment method than the one linked to your existing contract.</p>`,
          },
          item3: {
            question: 'How can I cancel MagentaTV independently of the internet provider?',
            answer:
              "First, log in to the 'Customer Center'. There you will find the button 'Manage products' under the tab 'Additional products without contract reference'. This takes you to your personal product overview. In the menu on the left, click on 'Contracts' and select your MagentaTV contract with the 'Contract details' button. Here you then have the option to cancel your MagentaTV contract.",
          },
          item4: {
            question:
              'What notice periods do I need to observe with MagentaTV Flex independently of the internet provider?',
            answer: 'You can cancel the Flex tariffs at any time with a notice period of 1 month.',
          },
          item5: {
            question: 'Where can I get more information?',
            answer: 'More information at <a>Book MagentaTV with the MagentaTV App | Telekom</a>',
            redirectionUrl: 'http://telekom.de/magenta-tv-mit-app',
          },
        },
        customerService: {
          headline: 'More questions?',
          description: 'Telekom customer service will be happy to help you personally',
          problemPhoneNumber: {
            number: '0800 33 01000',
            text: 'MagentaTV disruption & login problems',
          },
          servicePhoneNumber: {
            number: '0800 33 04000',
            text: 'MagentaTV consultation',
          },
        },
        termsOfService: {
          bullet1:
            'Registered users of Suchen+ for rent, Wohnen+ or Suchen+ for buy who have generated a MagentaTV voucher in one of these areas can use this voucher code to book MagentaTV Flex from March 1, 2025 for €8.50 per month instead of €10.00.',
          bullet2: 'The minimum contract term for MagentaTV Flex is 1 month.',
          bullet3:
            'This promotion cannot be combined with other promotions or vouchers and is only valid for MagentaTV new customers.',
          bullet4:
            'MagentaTV can be received via the MagentaTV app without additional hardware. If desired, the MagentaTV One can be purchased for €5/month with a minimum contract term of 12 months.',
          bullet5:
            'Prerequisite for use is an existing internet connection. The terms of the respective internet provider apply to the internet connection.',
          bullet6: 'When using the mobile data network, the data volume is charged by the respective mobile provider.',
          bullet7: 'The voucher is valid until December 31, 2026.',
        },
      },
    },
    rechtsberatung: {
      headline: 'Telephone rental-law advice',
      modal: {
        image: 'New building in the sunshine',
        overview: {
          entitled: {
            paragraph1: 'Do you have questions about tenancy and real estate law?',
            paragraph2: 'ARAG tenancy law advice provides an initial telephone consultation up to twice a year.',
          },
          notEntitled: {
            paragraph1: 'Do you have questions about tenancy and real estate law?',
            paragraph2: 'ARAG tenancy law advice provides an initial telephone consultation up to twice a year.',
            bullet1: 'Advice from qualified lawyers at ARAG Assistance',
            bullet2: 'Initial telephone advice for up to three tenancy law questions per year',
            bullet3: 'Included in {BuyerPlusLogo}',
            bullet3Light: 'Included in {BuyerPlusLogo} S, M and L',
          },
        },
        howItWorks: {
          image1: 'Telephone receiver',
          image2: 'scale',
          paragraph1:
            'For legal problems and questions relating to tenancy and property law, contact ARAG by phone for an informed legal opinion.',
          paragraph2: 'You can find the contact details in the overview.',
        },
        faq: {},
        linkButton: 'Discover Wohnen+',
      },
    },
    schluesseldienst: {
      headline: 'Emergency locksmith service',
      modal: {
        image: 'New building in the sunshine',
        overview: {
          entitled: {
            paragraph1: 'Protected in an emergency with ARAG locksmith service',
            paragraph2:
              "Lost your keys? ARAG's emergency locksmith service covers emergency door opening costs up to €500.",
          },
          notEntitled: {
            paragraph1: 'Protected in an emergency with ARAG locksmith service',
            paragraph2:
              "Lost your keys? ARAG's emergency locksmith service covers emergency door opening costs up to €500.",
            bullet1: 'Up to two incidents per year',
            bullet2: 'Up to €500 covered per emergency door opening',
            bullet3: 'Included in {BuyerPlusLogo}',
            bullet3Light: 'Included in {BuyerPlusLogo} S, M and L',
          },
        },
        howItWorks: {
          image1: 'Telephone receiver',
          image2: 'scale',
          paragraph1: 'Report an emergency to ARAG by phone at any time and get immediate help.',
          paragraph2: 'You can find the contact details in the overview.',
        },
        faq: {},
        linkButton: 'Discover Wohnen+',
      },
    },
    mietrechtsschutz: {
      headline: 'Tenancy legal protection',
      modal: {
        image: 'New building in the sunshine',
        overview: {
          entitled: {
            paragraph1: 'Rental legal protection supports you in a legal dispute',
            paragraph2:
              'If an initial telephone consultation and mediation cannot resolve a conflict, tenancy legal protection supports you with the next steps.',
            info150: 'A deductible of €150 applies.',
            infoFree: 'This service is free of charge for you.',
          },
          notEntitled: {
            paragraph1: 'Rental legal protection supports you in a legal dispute',
            paragraph2:
              'If an initial telephone consultation and mediation cannot resolve a conflict, tenancy legal protection supports you with the next steps.',
            bullet1: 'Advice from qualified lawyers at ARAG Assistance',
            bullet2: 'Choose a €150 or €0 deductible per case',
            bullet3: 'Included in {BuyerPlusLogo}',
            bullet3Light: 'Included in {BuyerPlusLogo} M and L',
          },
        },
        howItWorks: {
          image1: 'Telephone receiver',
          image2: 'scale',
          paragraph1:
            'For legal problems and questions relating to tenancy and property law, contact ARAG by phone or email.',
          paragraph2: 'You can find the contact details in the overview.',
        },
        faq: {},
        linkButton: 'Discover Wohnen+',
      },
    },
    mediation: {
      headline: 'Mediation',
      modal: {
        image: 'New building in the sunshine',
        overview: {
          entitled: {
            paragraph1: 'Do you need help resolving a conflict?',
            paragraph2: 'ARAG mediation supports you in disputes between tenants and landlords.',
          },
          notEntitled: {
            paragraph1: 'Do you need help resolving a conflict?',
            paragraph2: 'ARAG mediation supports you in disputes between tenants and landlords',
            bullet1: 'Mediation is a voluntary process for resolving conflicts between tenants and landlords',
            bullet2: 'You can use this service for disputes up to twice a year',
            bullet3: 'Included in {BuyerPlusLogo}',
            bullet3Light: 'Included in {BuyerPlusLogo} S, M and L',
          },
        },
        howItWorks: {
          image1: 'Telephone receiver',
          image2: 'scale',
          paragraph1: 'Mediation helps resolve disputes between tenants and landlords. Contact ARAG by phone or email.',
          paragraph2: 'You can find the contact details in the overview.',
        },
        faq: {},
        linkButton: 'Discover Wohnen+',
      },
    },
    consumerBenefitSchufa: {
      headline: 'Credit Report',
      modal: {
        overview: {},
        faq: {},
      },
    },
    deposit: {
      headline: 'Rent deposit guarantee',
      modal: {
        headline: 'Rent deposit guarantee',
        overview: {
          image: 'Rental deposit guarantee',
          pendingText: 'Your application is being processed by Allianz. This usually takes one working day.',
          depositNotifications: {
            cancelation: {
              headline: 'Rental deposit guarantee with Allianz canceled',
              messsage: 'Your rental deposit guarantee with Allianz was terminated on {dateAt}',
            },
            reduction: {
              headline: 'The deposit amount was reduced',
              messsage: 'The deposit amount was reduced at Allianz',
            },
          },
          depositStatusFrame: {
            statusTitle: 'Guarantee active at Allianz',
            sectionTitles: {
              customerNumber: 'Your customer number',
              depositStart: 'Start of the deposit guarantee',
              depositAmount: 'Amount of the deposit',
              monthlyContributionEntitled: 'Monthly contribution',
              monthlyContribution: 'Monthly contribution',
            },
            monthlyContributionEntitledInfo:
              'After termination of your Tenant Plus membership, costs of 4.7% of your deposit amount per year will be incurred for the Allianz rental deposit guarantee. These costs are to be paid to us pro rata per month via your payment method until the original deposit certificate is returned',
            faqLinkText: 'How can I cancel?',
          },
          rejectedStatus: {
            headline: 'Rental deposit guarantee rejected',
            message: 'Your application has been rejected by Allianz',
          },
          productDescription: {
            overviewHeadline: 'Arrive first - the deposit is already there',
            overviewParagraph1:
              'A rental deposit guarantee is an alternative to the classic cash deposit. Give your:landlord:the Allianz guarantee certificate (max. deposit amount €5,000) instead of paying up to three months rent deposit.',
            overviewParagraph2:
              'If the deposit has already been paid, you may receive your cash deposit back from the landlord',
            checkmark1: 'Do not pay a cash deposit',
            checkmark2: 'As a short or long-term solution',
            checkmark3: 'No minimum contract term, no notice period',
            checkmark4: 'Included in {badgeLabel}',
            tenant: 'Tenant',
          },
          customerService: {
            headline: 'Any questions?',
            description: 'The Allianz customer service will be happy to help you personally',
            phoneNumber: '0800 / 900 40 04',
            workingHours: 'Mon - Fri 8-21h and Sat 9-17h',
            email: 'allianz-mietkaution@kautionskasse.de',
          },
        },
        howItWorks: {
          image1: 'Discount coupon',
          image2: 'Moving dolly',
          image3: 'Dolly trolley',
          description1: 'Fill in and send the application form online',
          description2: 'Guarantee certificate sent by post the next working day',
          description3: 'Simply present the certificate to the landlord and save the deposit',
        },
        faq: {
          item0: {
            question: 'How does the Allianz rental deposit work?',
            answer:
              '<p>By concluding the insurance contract, Allianz undertakes to guarantee the landlord for the contractually agreed deposit amount. After conclusion of the contract, the tenant receives a guarantee certificate to hand over to the landlord.</p><p>If the landlord legitimately requests access to the rental security (in the event of damage), Allianz will initially act on behalf of the tenant and the deposit claim will be paid immediately . Allianz then takes recourse against the tenant. She is supported in this by a debt collection service provider who specializes in professional receivables management.</p>',
          },
          item1: {
            question:
              'Is the Allianz rental deposit also suitable for a short period of time, e.g. as interim financing?',
            answer:
              '<p>Yes, the tenant can also use the Allianz rental deposit for a short period of time. Since the product can be terminated at any time by returning the guarantee certificate, it is also conceivable as interim financing.</p>',
          },
          item2: {
            question: 'What is a first demand guarantee?',
            answer:
              "<p>On first request means: The guarantor must generally pay out to the landlord upon request from the landlord and a reasonable inspection period (for the tenant's statement). If the formal requirements of the guarantee agreement are met, the tenant can only prevent a payment by proving beyond doubt that the landlord has clearly abused the law.</p>",
          },
          item3: {
            question: 'What role does the German Surety Fund play within the framework of the insurance contract?',
            answer:
              '<p>Deutsche Sicherskasse AG (DKK) is entrusted with the administration of rental deposit insurance as a service provider for Allianz Versicherungs-AG. The DKK takes over application, inventory and claims processing.</p>',
          },
          item4: {
            question: 'Who can take out the Allianz rental deposit?',
            answer:
              '<p>The Allianz rental deposit can only be taken out by natural persons in their capacity as tenants of a privately used residential unit located in Germany. The landlord himself cannot do this in principle.</p>',
          },
          item5: {
            question: 'Who and what is insured with the Allianz rental deposit?',
            answer:
              "<p>The landlord's risk is insured that the tenant does not properly fulfill his payment obligations under the rental agreement. The landlord may then be legally entitled to access the rental deposit (benefit event), e.g. due to rent due or damage to the rental property.</p>",
          },
          item6: {
            question: 'What are the payment methods and terms?',
            answer:
              "<p>Only after the TenantPlus membership has ended will costs for Allianz's rental deposit guarantee amount to 4.7% of the deposit amount per year. These costs must be paid proportionately per month until the original deposit certificate is returned to ImmoScout24 using the payment method provided.</p>",
          },
          item7: {
            question: 'What information is required for the application?',
            answer:
              '<ul><li>Tenant data (according to rental agreement)</li><li>Data on the rental property (according to rental agreement)</li><li>Data on the landlord (according to rental agreement)</li><li>Date of rental start </li><li>Information on the bank details of a financial institution represented in Germany </li><li>if necessary a copy of the identity card or rental agreement </li></ul>',
          },
          item8: {
            question: 'Is there a minimum contract term?',
            answer: '<p>No, there is no minimum term for the Allianz rental deposit.</p>',
          },
          item9: {
            question: 'How long does the cancellation period last?',
            answer:
              '<p>The concluded contract can be revoked in text form (e.g. letter, email) within 14 days of receipt of the contract documents. For final processing, in particular the cancellation of the payment obligation, the original guarantee certificate must be sent back to the German Guarantee Fund (key date: date of receipt of the certificate):</p>' +
              '<p>Deutsche Guarantee Fund AG</p><p>Allianz Mietkaution</p>' +
              '<p>Gautinger Str. 10</p>' +
              '<p>82319 Starnberg</p>',
          },
          item10: {
            question: 'Why does the document have to be returned in the original if it is revoked?',
            answer:
              '<p>The guarantee document certifies the guarantee promise to the landlord. When the original certificate is handed over to the landlord (guarantor beneficiary), it becomes fully valid as rental security (from the start of the guarantee noted on the document).</p><p>As long as the original guarantee certificate is not sent to our service provider, the German Guarantee Fund , is returned, it can be assumed that it serves its actual security purpose, the provision of the rental deposit.</p>',
          },
          item11: {
            question: 'How high is the insurance premium?',
            answer:
              '<p>Only after your Tenant Plus membership has ended will the Allianz rental deposit guarantee cost you 4.7% of your deposit amount per year. These costs must be paid to us pro rata per month until the original deposit certificate is returned to us via your deposited payment method.</p>',
          },
          item12: {
            question: 'Contribution payment, what is it for?',
            answer:
              '<p>The annual contribution to be paid for the Allianz rental deposit is to be paid for the assumption of liability by Allianz Versicherungs-AG as a guarantor towards the landlord.</p><p>Important: The rental deposit guarantee is not a financing instrument. The tenant does not pay or save any rental deposit.</p>',
          },
          item13: {
            question: 'When does the insurance cover start? When is the landlord insured?',
            answer:
              '<p>The landlord enjoys full insurance cover if he has the original guarantee certificate, but at the earliest from the date stated on it.</p>',
          },
          item14: {
            question: 'Are changes to the guarantee deed possible?',
            answer:
              '<p>If clerical errors are not risk-related, a corrected certificate can be issued. To do this, the original guarantee certificate, including any changes requested, must be sent by post to the following address:</p><p>Deutsche Guarantee Fund AG</p><p>Allianz Mietkaution</p><p>Gautinger Straße 10</p> <p>82319 Starnberg</p><p>If risk-relevant information is incorrect, the contract must be terminated by returning the original certificate and a new application must be submitted.</p>',
          },
          item15: {
            question: 'Loss of the surety certificate, what should I do?',
            answer:
              '<p>In the event of loss, a declaration of loss (form) signed by the tenant and landlord is required. After receiving the notification, a replacement certificate will be issued free of charge or, in the event of revocation or termination, the contract will be terminated. The guarantee certificate reported as a loss therefore loses its validity.</p>',
          },
          item16: {
            question: 'How much is the insured sum?',
            answer:
              '<p>BThe insured sum corresponds to the secured deposit amount. The insurable deposit amount is based on legal requirements (§551). The landlord may demand a maximum security amounting to three times the monthly rent without additional costs. If this sum has been paid out, the insurance contract expires.</p>',
          },
          item17: {
            question: 'What should be taken into account when canceling?',
            answer:
              '<p>The Allianz rental deposit can be terminated at any time by returning the certificate. The obligation to pay ends when the original document is received by the German Security Guarantee Fund.</p><p>The contract will then be billed to the exact day and any excess paid will be refunded pro rata. A cancellation confirmation will be sent in writing with the final bill.</p><p>There is no minimum contract term or notice period.</p>',
          },
          item18: {
            question: "What should you do if the landlord doesn't hand over the deed?",
            answer:
              "<p>The tenant must request the landlord to hand over the document and set a deadline. It should be noted that the landlord only has to return a rental security after a reasonable period of 6 to 12 months has elapsed from the end of the rental agreement.</p><p>If there is no discernible reason for the landlord's behavior, it should the tenant should seek legal advice. In this case, real estate legal protection insurance is helpful</p>",
          },
          item19: {
            question: 'Can the amount of the rental deposit be reduced when moving out?',
            answer:
              '<p>Yes, the German Deposit Fund requires a letter from the landlord stating the reduction request, as well as the original guarantee certificate.</p><p>The contract is then billed on a daily basis based on the original guarantee amount and any existing credit is included proportionately deducted from the contribution for the reduced deposit amount (key date: date of receipt of the document). The landlord receives a new document which he keeps, for example, until the additional costs are settled.</p>',
          },
          item20: {
            question: 'When does the insured event occur?',
            answer:
              '<p>The insured event occurs when the landlord requests payment of the guarantee amount in whole or in part.</p>',
          },
          item21: {
            question: 'What should be done in the event of damage?',
            answer:
              '<p>The landlord should promptly report any use of the Allianz rental deposit to the German Deposit Fund. The claim form can be requested by telephone at <strong>0800-900 30 20</strong> or by email at <strong> Schaden-allianz-mietkaution@kautionskasse.de</strong>.</p><p >The form must be completely filled out by the landlord, signed and sent to the German Deposit Fund together with the original guarantee certificate and a copy of the rental agreement:</p><p>Deutsche Guarantee Fund AG</p><p>Allianz Mietkaution</p><p>Allianz Mietkaution</p> p><p>Gautinger Straße 10</p><p>82319 Starnberg</p><p>Please note: In the event of a claim, the policyholder (tenant) will not receive any payments from the insurance. Rather, he must refund the amounts paid to the landlord to us.</p><p>If the tenant believes that a claim from his landlord is not justified, he may have to immediately take legal action against the landlord in order to prevent his access to the rental security prevent.</p>',
          },
          item22: {
            question: 'Which services are excluded?',
            answer:
              "<p>The policyholder himself is not entitled to any (monetary) payments under the insurance contract. The guarantor's obligation to pay only exists towards the landlord and only up to the agreed deposit amount. Claims by the landlord which do not entitle them to access the deposited rental security under the applicable legal situation are also excluded.</p>",
          },
          item23: {
            question: 'What happens after the landlord reports the damage?',
            answer:
              '<p>As soon as the landlord has specifically quantified his claims, the tenant will be informed and asked to comment. After the comment period has expired and all documents have been checked, the requested amount will be paid to the landlord if the claim is justified. This process usually takes around 14 days.</p><p>If the German security fund informs you of a damage, you will receive a damage form with a request to send it back including the requested documents. As soon as these documents are complete, the tenant will be informed accordingly and asked to comment. After the comment period has expired and the documents have been checked, the deposit amount will be paid out to the landlord.</p><p>If the tenant submits liquid evidence of the non-existence of the claim or other circumstances that indicate an obvious abuse of law within the comment period, the The required deposit amount was not paid out.</p><p>The liquid evidence includes legally binding judgments, other titles, reports from court-appointed experts and other documents. Objections without the presentation of liquid evidence cannot generally be taken into account.</p><p>Important: after the payment has been made to the landlord, the tenant receives a statement from the guarantor and must repay the amount paid out to him.</p>',
          },
          item24: {
            question: 'Why does the tenant have so little time to respond to the damage report (comment period)?',
            answer:
              '<p>The Allianz rental deposit is a guarantee upon first request, which serves as security for the landlord. In order for the landlord to accept this type of rental security, it must be ensured that, in an emergency, he can access it just as easily as another form of rental security.</p><p>For this type of security, formal registration is sufficient the claim and submitting the original document for payment. Proof of the claim, as we know from other insurance products, is not required.</p><p>If the landlord demands the deposit, the tenant will be notified immediately in writing. This gives the tenant the opportunity to submit liquid funds to defend against a potentially unlawful claim.</p>',
          },
          item25: {
            question:
              'What happens if the original guarantee certificate is no longer available to the landlord in the event of damage?',
            answer: '<p>In this case, a declaration of loss (form) signed by the tenant and landlord is required.</p>',
          },
          item26: {
            question: 'Is there a deductible in the event of damage?',
            answer:
              '<p>There is no deductible for the landlord. The tenant (policy holder), on the other hand, is obliged to fully refund to us any amounts paid to his landlord under the guarantee in the event of damage.</p>',
          },
          item27: {
            question: 'Why do we approach the tenant after paying the damage?',
            answer:
              '<p>With the payment to the landlord, we obtain recourse against the tenant (policy holder) in the amount of the deposit amount paid out. The tenant will be informed by the German Deposit Fund about the payment to his landlord and asked to refund the corresponding amount.</p>',
          },
        },
        activeButton: 'Activate rental deposit guarantee',
        buttonCta: {
          continueWithDiscount: 'Continue with 5% discount',
          redeemDiscout: 'Redeem discount',
        },
      },
    },
    relocationService: {
      headline: 'Moving Service',
      modal: {
        headline: 'Moving Service',
        image: 'Moving',
        overview: {
          paragraph1: 'With Movinga you can enjoy the new way of moving.',
          paragraph2:
            "As Europe's leading moving provider, they take care of the planning, while a local moving partner takes care of your move.",
          bullet1: 'Comparison of over 550 qualified and verified moving companies',
          bullet2: 'Digital creation of your moving list',
          bullet3: 'Changes & cancellation up to 14 days before moving',
          alt: {
            paragraph1: 'Request free quotes for your move',
            paragraph2:
              'Receive up to 5 non-binding quotes from moving companies in your area. Comparing quotes is worthwhile, as you can save up to 40% on your move.',
            bullet1: 'Exclusive discount for {MieterPlusLogo} members!',
            bullet2: 'Discover Suchen+ for rent',
          },
        },
        howItWorks: {
          image1: 'Police',
          image2: 'scale',
          image3: 'Telephone receiver',
          paragraph1:
            'Submit moving details and upload photos of your furnished rooms. With just one click, the moving list is created and you receive an initial offer - of course free of charge and non-binding.',
          paragraph1alt: 'Specify moving dates. Simply enter the desired dates for your move.',
          paragraph2:
            'Receive comprehensive and personal moving advice. The moving offer is individually tailored to your needs and budget.',
          paragraph2alt: 'Find professional helpers. We find the right professionals for your individual move.',
          paragraph3: 'Move with a professional moving company while Movinga takes care of the moving stress from A-Z.',
          paragraph3alt: 'Move stress-free. Move into your new home stress-free and relaxed.',
        },
        faq: {
          item0: {
            question: 'How do I reach the moving company?',
            answer:
              'Since Movinga works with moving companies all over Germany, we are happy to be your contact person. You can easily reach us via our website movinga.com, telephone +49 30 76758002 (Mon - Fri 8:00 a.m. - 7:00 p.m. & Sat. 9:00 a.m. - 5:00 p.m.) or email. Simply tell us your moving details using our online form and receive your moving offer within three minutes. If you would prefer to speak to us personally, we look forward to your call!',
          },
          item1: {
            question: 'What is Movinga?',
            answer:
              'Movinga was founded to bring moving into the twenty-first century. We would like to combine the advantages of a digital platform with the service of personal advice and thus enable you to have a stress-free move with the help of professional moving helpers. We particularly focus on personal service, comprehensive advice and the cheapest price on the market. This way we can ensure that your moving experience is as comfortable as possible and that you feel in good hands with us right from the start. Thanks to our digital moving calculator, we can make you a non-binding offer quickly and transparently.',
            redirectionUrl: 'https://www.umzugsfirmen-check.de/',
          },
          item2: {
            question: 'How is my move going?',
            answer:
              'Movinga offers you a comprehensive moving service. This means we relieve you of the tedious and time-consuming search for a suitable moving company in your area and accompany you through the entire booking process. After you have provided us with your moving information, we will provide you with a free quote, assign you a personal moving consultant and select a moving company in your area for you. If desired, additional services can be booked through us, such as a parking ban in front of your house or the sending of packaging materials. Do you have any special wishes or concerns that are out of the norm? Just talk to us - your personal advisor will surely find a solution for you.',
          },
          item3: {
            question: 'How long does a move with a moving company take?',
            answer:
              'A move with a moving company can be completed in a day or even just a few hours, especially for local moves. The exact duration depends on the services booked, such as furniture assembly or disassembly.',
          },
          item4: {
            question: 'More questions? ',
            answer: 'If you have any questions, you can find more information about our moving service <a>here</a>.',
            redirectionUrl: 'https://www.umzugsfirmen-check.de/',
          },
        },
        linkButton: 'Request a non-binding offer',
      },
    },
    addressChange: {
      headline: 'Digital address change',
      modal: {
        headline: 'Digital address change',
        image: 'Digital address change',
        overview: {
          START_PREMIUM: {
            paragraph1: 'Start digital address change',
            paragraph2:
              "You're moving soon? We recognize & notify all relevant recipients about your change of address.",
            ctaText: 'Start address change',
            bullet1: 'All digital, no paperwork',
            bullet2: 'Address change completed in under 5 minutes',
            bullet3: 'Highest security standard for data handling',
          },
          CONTINUE: {
            paragraph1: 'Continue digital address change',
            paragraph2: 'You already have an address change in progress. Complete your address change now.',
            ctaText: 'Complete address change',
          },
          NOT_ELIGIBLE_USED_MP: {
            paragraph1: 'Change of address from Suchen+ for rent 12 already used',
            paragraph2:
              'You have already used your included change of address. You can purchase further changes of address individually.',
            ctaText: 'Buy address change',
            bullet1: 'Everything digital, no paperwork',
            bullet2: 'Change of address completed in under 5 minutes',
            bullet3: 'Highest security standard for data handling',
          },
          NOT_ELIGIBLE: {
            paragraph1: 'The digital change of address is not included in your membership',
            paragraph2:
              'Are you moving soon? We will recognize & notify all relevant recipients about your change of address. You can purchase your change of address individually.',
            ctaText: 'Buy change of address',
            bullet1: 'Everything digital, no paperwork',
            bullet2: 'Change of address completed in under 5 minutes',
            bullet3: 'Highest security standard for data handling',
          },
        },
        faq: {},
      },
    },
    greenElectricity: {
      headline: 'KlarWatt Green Electricity',
      modal: {
        headline: 'KlarWatt Green Electricity',
        image: 'KlarWatt Green Electricity',
        overview: {
          paragraph1: 'Exclusive Wohnen+ discount: No service fee for the first 12 months (instead of €4.99 per month)',
          paragraph2:
            'As a Wohnen+ member, you benefit from an exclusive discount on KlarWatt, the dynamic green electricity tariff from ImmoScout24. Thanks to daily market-based pricing, you can save up to 40% – with a price cap of 37.89 cents/kWh and the flexibility of monthly cancellation.',
          ctaText: 'Calculate your discounted tariff now',
          discoverWohnenPlus: 'Discover Wohnen+',
        },
        faq: {},
      },
    },
    keyEmergency: {
      headline: 'Emergency key service',
      modal: {
        faq: {},
        headline: 'Emergency key service',
        image: 'Emergency key service',
        overview: {
          paragraph1: 'Insured in an emergency with the emergency locksmith service from AXA Assistance',
          paragraph2: 'Key lost? AXA Assistance covers costs of up to 500 euros in the event of an emergency opening.',
          bullet1: 'Immediate opening of the apartment door',
          bullet2: 'available to you 24/7',
          bullet3: 'Costs up to a maximum of EUR 500 will be covered',
          bullet4: 'Included in {BuyerPlusLogo}',
          request: {
            keyEmergencyService: {
              title: 'Activation successful',
              text: 'The emergency locksmith service was successfully activated.',
              insuranceStatus: {
                title: 'Service active',
                deaktivieren: '(deactivate)',
                kundennummer: 'Your customer number',
                versicherungsnummer: 'Insurance number',
                anschrift: 'Your address',
                kontaktdaten: 'Emergency contact details',
                dokumente: 'Documents',
                cancellationText: 'Are you sure you want to deactivate the emergency locksmith service?',
                cancellationButton: 'Deactivate',
                cancellationButtonCancel: 'Cancel',
                edit: 'edit',
                customerService: {
                  phoneNumber: '0221 80247 1360',
                  phoneNumberText: ' Available around the clock every day',
                  email: 'immobilienscout24@axa-assistance.de',
                },
              },
              axaFooter: {
                title: 'You lost your key and need help?',
                text: "With AXA's emergency locksmith service, costs up to a maximum of EUR 500 are covered.",
                companyName: 'Inter Partner Assistance Service GmbH',
                companyStreet: 'Große Scharmstraße 36',
                companyCity: '15230 Frankfurt (Oder)',
              },
            },
            title: 'Activation required',
            description:
              'You must take out the emergency locksmith service in advance so that you are covered in an emergency.',
            customerService: {
              headline: 'Any questions?',
              text: 'LAGERBOX customer service will be happy to help you personally',
              phoneNumber: '0800 / 222 666 999',
              businessHours: 'Mon - Fri 8 a.m. - 9 p.m.',
              businessHoursWeekend: 'Sat 9 a.m. to 5 p.m.',
              email: 'immobilienscout@lagerbox.com',
            },
          },
        },
        howItWorks: {
          image1: 'Police',
          image2: 'scale',
          image3: 'Telephone receiver',
          paragraph1: 'Activate emergency locksmith service online in under 2 minutes and receive contact details.',
          paragraph2: 'Report an emergency to AXA Assistance by telephone at any time.',
          paragraph3:
            'AXA Assistance organizes the opening of the apartment door by a locksmith and covers the costs incurred up to a maximum of 500 euros.',
        },
        form: {
          title:
            'Simply submit the form and you will immediately receive a confirmation email with contact details for tenancy law advice:',
          footerText:
            'I agree that my data will be transmitted to <a href="https://www.axapartners.de/" target="_blank" rel="noreferrer"> AXA Assistance </a> and processed there for the purpose of providing services be used. I further agree that, to the extent that this serves the proper implementation of the insurance matter, AXA Assistance will combine general contract, billing and performance data into common data collections of the insurance group. Further information on how to handle your data can be found <a href=https://www.axapartners.de/datenschutz" target="_blank" rel="noreferrer"> here </a>.',
          cancelButtonText: 'Cancel',
          submitButtonText: 'Activate now',
          saveButtonText: 'Save',
          backButtonText: 'Back',
          city: {
            label: 'City',
            placeholder: '',
          },
          salutation: {
            label: 'Salutation',
            options: {
              female: 'Ms',
              male: 'Mr.',
            },
          },
          firstName: {
            label: 'First name',
            placeholder: '',
          },
          lastName: {
            label: 'Last name',
            placeholder: '',
          },
          street: {
            label: 'Street',
            placeholder: '',
          },
          houseNumber: {
            label: 'House number',
            placeholder: '',
          },
          postcode: {
            label: 'Postal code',
            placeholder: '',
          },
        },
        linkButton: 'Discover Wohnen+',
        activeButton: 'Activate emergency key service',
      },
    },
    billCheckV3: {
      headline: 'Additional costs check',
      multiStepFlow: {
        progressBar: {
          step: 'Step',
        },
        balanceDetailsStep: {
          title: 'Details about your billcheck',
          form: {
            balanceType: 'Your result',
            balanceAmount: 'Amount',
            balanceAmountPlaceholder: 'e.g. 1.500',
            radioGroup: {
              additionalPayment: 'Additional payment',
              credit: 'Credit',
            },
            errorMessages: {
              negativeBalanceAmount: 'Balance ammount must be 0 or greater',
            },
          },
        },
        accountingPeriodDetailsStep: {
          title: 'Utility Bill Statement Details',
          form: {
            accountingPeriodDates: 'Accounting Period',
            deliveryDate: 'Delivery Date',
            deliveryDatePlaceholder: 'e.g. 16.06.2025',
            validation: {
              futureDateError: 'Delivery date cannot be in the future',
              invalidStartDateError: 'Accounting period start date cannot be in the future',
              invalidEndDateError: 'The accounting period end date must be after the accounting period start date',
            },
          },
        },
        customerDetailsStep: {
          title: 'Personal Information',
          form: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            gender: 'Salutaion',
            selectPlaceholder: '-Please select-',
          },
        },
        rentalContractUploadStep: {
          title: 'Upload rental agreement',
          subtitle: 'Please upload all pages and attachments',
          submitCta: 'Complete and submit',
        },
        operationalStatementUploadStep: {
          title: 'Upload utility bill',
          subtitle: 'Please upload all pages and attachments',
        },
        common: {
          mandatoryField: 'Required field *',
          uploadTitle: 'Add document here',
          rentalContractUploadSubtitle: 'Rental agreement',
          utilityBillcheckUploadSubtitle: 'Utility bill',
        },
        fileInput: {
          fileSelectionConditionsDesktop: 'PDF/ JPEG/ PNG up to 25 MB',
          fileSelectionConditions: 'PDF/ JPEG/ PNG up to 25 MB',
          documentSelectionCtaDesktop: 'Select document',
          documentSelectionCta: 'Select document',
          errorMessages: {
            exceedingFileSize: 'The size of the document cannot exceed 25 MB',
            unsupportedFileTypeSelection: 'Only PDF, JPEG and PNG file types are supported',
            exceededMaxNumberOfAllowedFiles: 'You can only add up to {maxNumberOfFiles} documents.',
          },
          infoLabel: {
            maxNumberOfFilesReached: 'You have reached the maximum ammount of allowed documents',
          },
        },
        loadingState: {
          dataBeingSubmitted: 'Data is transmitted',
          fileUploadProgress: 'files uploaded',
        },
        errorState: {
          serviceUnavailable: {
            message: 'Something went wrong! Please try selecting your douments and submitting your information again.',
            ctaLabel: 'Start input again',
          },
          tryAgain: {
            message: 'Something went wrong! Please try again at a later date.',
            ctaLabel: 'Back to the plus area',
          },
        },
      },
      modal: {
        buttonCta: {
          startBillcheck: 'Start utility bill check',
          continueBillCheck: 'Continue utility bill check',
          startCheck: 'Start check',
        },
        image: 'Paper, pencil and calculator',
        faq: {},
        overview: {
          discoverWohnenPlusCta: 'Discover Wohnen+',
          billCheckNotification: {
            headline: 'Missing details',
            description1: 'Please complete the remaining details.',
            description2: 'Continue order',
          },
          billCheckList: {
            title: 'My review requests',
            orderNumberColumnLabel: 'Order no.',
            dateColumnLabel: 'Date',
            startNewOrderCta: 'Start a new order',
            description:
              'As a Wohnen+ member, you can have your utility bill checked free of charge once a year. You can have your utility costs checked again on <b>{nextCheckDate}</b>.',
          },
          statusBox: {
            done: {
              headline: 'The review of your documents has been completed',
              description: 'We have emailed you the result of the review.',
            },
            submitted: {
              headline: 'The review of your documents has started',
              description: 'You will receive the result by email within 5 business days.',
            },
            ordered: {
              headline: 'You have an incomplete review.',
              description: 'Please continue your registration on the Mineko website to complete the process.',
            },
            ctaLabel: 'Continue registration',
            ticketNumberInfo: '<b>Your order number: </b>{minekoTicketId}',
            ticketNumberInfoLabel: '<b>Your order number: </b> ',
          },
          footer: {
            customerService: 'Customer service',
            paragraph: 'If you have any questions, we are happy to help:',
            phoneNumber: '+49 30 40365750',
            operatingHours: 'Mon - Fri 9:00 - 18:00',
            contactEmail: 'kontakt@mineko.de',
          },
          title: 'Get money back from your landlord with the quick utility bill check',
          paragraph1:
            "Many utility bills are too high. Have your bill checked by Mineko's legal experts and get money back from your landlord if errors are found.",
          checklist: {
            item1: 'Conveniently upload a scan or photo from home',
            item2: 'Receive your personal review result from experts within 5 days',
            item3: 'Included once a year in {LivingPlusLogo}',
          },
        },
        howItWorks: {
          image1: 'Top of the inbox',
          image2: 'Opened mail',
          image3: 'Euro symbol',
          description1: 'Conveniently upload your rental agreement and utility bill as photos or scans from home.',
          description2:
            'Receive a detailed review report and a personalized objection letter within 5 days and forward them to your landlord.',
          description3: 'Your landlord prepares a new, correct bill and refunds any overpayments.',
        },
      },
    },
    tenantProtectionServices: {
      headline: 'Tenant Angel Tenant Protection',
      modal: {
        image: 'Tenant Angel Tenant Protection',
        overview: {
          paragraph: 'With MietEngel you are covered in the event of rental problems. Digital and modern.',
          var1: 'Included in MietenPlus and Wohnen+ - from the first day.',
          var2: 'Included in TenantPlus (with 6 & 12 month minimum term).',
          checkmark: {
            title: 'More security with TenantEngel:',
            list: {
              item1: {
                title: 'Have your rental agreement checked:',
                text: 'Whoever knows their rights gets justice. But do you know every detail in your rental agreement?',
              },
              item2: {
                title: 'Get your money back:',
                text: 'Rising prices are causing utility costs to skyrocket. But did you know that every second utility bill contains errors and that you can save an average of €250 if you check them? How about yours?',
              },
              item3: {
                title: 'Tackling problems early:',
                text: 'Everything looked good when we moved in, but after the first rain there was a water stain, what now?',
              },
              item4: {
                title: 'Get advice on impending conflicts:',
                text: 'Whoever knows their rights gets justice. But do you know every detail in your rental agreement?',
              },
              item5: {
                title: 'Have your rental agreement checked:',
                text: 'What to do if there are invalid paragraphs in the contract or incomprehensible landlord letters?',
              },
            },
          },
          bulletList: {
            title: 'Your legal advice from partner lawyers',
            item1: 'To all rental problems',
            item2: 'By telephone & in writing',
            item3: 'Reply usually within 48h',
            item4: '1x annual additional cost check',
            item5: 'Fixed contact person throughout the year',
          },
          footerSection: {
            title: 'More tenant angel benefits:',
            list: {
              item1: 'Online customer account & support by TenantEngel Team',
              item2: 'Tenancy law simple & understandable: 200+ guides, checklists and templates',
              item3: 'Templates & editor for your communication with landlords or property management',
            },
          },
        },
        howItWorks: {
          image1: 'Paper and Pen',
          image2: 'Opened envelope',
          image3: 'Download icon',
          image4: 'Coin',
          title1: 'Activate TenantAngel',
          title2: 'Ask your question',
          title3: 'Legal advice from partner lawyers',
          paragraph1:
            'Get access to MietEngel from day one. When you register on the portal, you will be assigned a personal lawyer. You can decide whether your concern should be examined in writing or by telephone.',
          paragraph2:
            'Your rental problem – your individual advice. Depending on the case, different documents are required. We will let you know which documents need to be uploaded regarding your rental problem (e.g. rental agreement, utility bill, letter from the landlord, etc.). This can be done directly via the browser or via the smartphone. Make sure photos and scans are easy to read!',
          paragraph3:
            'In writing or by telephone. No matter how full your schedule or how long your to-do list is. Individual tenant protection tailored directly to you. You decide whether your concern should be examined in writing or by telephone. As soon as all documents are uploaded, you will receive a response within a few days. If you would prefer to speak to the partner lawyer by telephone, you will receive an appointment that is accurate to the minute and can be easily scheduled.',
        },
        faq: {
          item0: {
            question: 'What is TenantEngel?',
            answer:
              "MieterEngel offers tenant protection throughout Germany. No matter whether it's a big city or a small community, MietEngel takes care of you as a tenant. You will receive out-of-court legal advice for all rental problems from selected partners via our WebApp. Ask your questions at any time and usually receive a written answer or a minute-by-minute telephone appointment within 48 hours.",
          },
          item1: {
            question: 'Who advises me?',
            answer:
              'The legal advice is provided by selected partner lawyers who are selected with particular care by MietenEngel. The prerequisite is that you have at least 5 years of practical experience in tenancy law. In addition, 85% have a doctorate and 80% are specialist lawyers in tenancy law. In addition to professional skills, we place particular emphasis on personal skills. Our partners know how to resolve conflicts quickly.',
          },
        },
        customerService: {
          headline: 'More questions?',
          text: 'If you have any questions, customer service will be happy to help you:',
          phoneNumber: '030 5557 1887',
          businessHours: 'Mon to Fri, 8 a.m. to 6:30 p.m.',
          businessHoursWeekend: 'Sat, 11 a.m. - 3 p.m.',
        },
        buttonBasic: 'Discover Wohnen+',
        buttonPlus: 'To the tenant angel portal',
      },
    },
    storageService: {
      headline: 'Storage space',
      modal: {
        headline: 'Storage space',
        image: 'Storage space',
        overview: {
          paragraph1: 'Rent additional space with a storage unit from LAGERBOX.',
          bullet1IsEntitled: 'From 1m³ / 1 week / 9,95 €',
          bullet1: 'Already from 9,95 € per month',
          bullet2: 'Germany-wide',
          bullet3: 'Exclusive discount with',
          subBullet1: '5 % discount on Basic package',
          subBullet2: '15 % discount on Premium package',
          WohnenPlusLink: 'Discover Wohnen+',
          request: {
            title: 'Request sent',
            description:
              'Your request has been sent successfully.  LAGERBOX will contact you by phone within the next 48 hours. If you have any further questions, please contact Lagerbox customer service ',
            customerService: {
              headline: 'Any questions?',
              text: 'The LAGERBOX customer service will be happy to help you personally',
              phoneNumber: '0800 / 222 666 999',
              businessHours: 'Mon - Fri 8-21 hrs',
              businessHoursWeekend: "Sat 9-17 o'clock",
              email: 'immobilienscout@lagerbox.com',
            },
          },
        },
        howItWorks: {
          image1: 'Paper and pen',
          image2: 'Opened envelope',
          image3: 'Storage room symbol',
          image4: 'Coin',
          paragraph1: 'Fill in and send the application form in just a few minutes',
          paragraph2: 'Receive offer from storage box within 48h',
          paragraph3: 'Rent storage space from LAGERBOX.',
        },
        faq: {
          item0: {
            question: 'What is self-storage?',
            answer:
              'Self-storage means storing your belongings yourself. At LAGERBOX, you rent an additional room for more space, in whatever size you need and for as long as you like.',
          },
          item1: {
            question: 'Do you offer help with moving or transport?',
            answer:
              'We provide available storage units, but do not handle storage logistics. As a customer, you are responsible for moving goods into and out of your storage unit. You can, of course, ask service providers such as moving companies, or friends and acquaintances, to help you fill your unit.',
          },
          item2: {
            question: 'Who else has access to my storage unit?',
            answer:
              'Security is a priority at LAGERBOX. Only you have access to your personal storage unit. If you wish, you can authorize other people to access it by naming them in the rental agreement or granting them temporary authorization. These people then have the same unrestricted access as you. Anyone authorized to enter must also have a key to the storage unit. You must be able to show our staff an official photo ID upon request.',
          },
          item3: {
            question: 'Can the storage units be locked?',
            answer:
              'Each LAGERBOX storage unit can be locked individually with a padlock. You can buy one affordably from the moving shop on site or bring your own.',
          },
          item4: {
            question: 'What should I consider when storing my belongings?',
            answer:
              'Use your storage space efficiently. If you are storing furniture for a long time, for example, it may be useful to disassemble it. We strongly recommend protecting fabrics, textiles and carpets from pests with moth repellents. Although LAGERBOX regularly takes preventive pest control measures in its storage facilities, we can never completely rule out infestations. Make sure textiles are dry and do not seal them in airtight packaging. Observe the maximum usable height of your storage unit when storing your belongings. You can find this in your rental agreement or ask our staff on site.',
          },
          item5: {
            question: 'How high are the storage units?',
            answer:
              'Our units are usually three meters high. Observing the maximum storage height is essential to ensure that our fire safety systems work correctly, which benefits all customers at our self-storage facilities. For more information, call the relevant LAGERBOX location and ask our staff.',
          },
          item6: {
            question: 'Does LAGERBOX offer a parcel acceptance service?',
            answer:
              'Yes, we are happy to accept parcels for our customers, but not in large quantities or every day. Larger or regular goods deliveries must be placed into storage by a freight company or received by the customer or an authorized representative.',
          },
          item7: {
            question: 'Are LAGERBOX facilities monitored by alarms and video surveillance?',
            answer:
              'Yes, LAGERBOX facilities have video surveillance and alarm systems. Your belongings are reliably monitored around the clock when you store them with us.',
          },
          item8: {
            question: 'Do you provide a free van when moving in?',
            answer:
              "Yes, the free van is one of our most popular extras! By prior arrangement, you can use a vehicle or trailer free of charge when moving in and out. Van use includes 30 kilometers and is available during the branch's office working day. Our staff will be happy to explain the exact conditions.",
          },
          item9: {
            question: 'Are transport aids such as sack trucks, pallet trucks and trolleys available free of charge?',
            answer:
              'Yes, free transport aids such as sack trucks, pallet trucks and trolleys are available for our customers to use at all LAGERBOX locations.',
          },
          item10: {
            question: 'What is the notice period?',
            answer:
              'The notice period depends on the contract term: monthly contracts have a notice period of one day.',
          },
          item11: {
            question: 'What if I need my storage unit for longer than planned? Will it still be available?',
            answer:
              'Yes, your storage unit remains available after your rental agreement ends, so you can extend your rental period.',
          },
          item12: {
            question: 'What happens if I need more or less space after signing the contract?',
            answer:
              'We are flexible. You can switch to a smaller unit after the first month. Switching to a larger unit is usually possible immediately. Both options depend on the availability of the desired storage unit. Please discuss this directly with the team at your LAGERBOX location.',
          },
          item13: {
            question: 'Do LAGERBOX facilities have covered loading areas?',
            answer:
              'Yes, all our locations have covered loading areas. These drive-in areas are part of our extra convenience services. They allow you to load and unload in dry conditions, even in bad weather, keeping your belongings dry and intact.',
          },
        },
        form: {
          footerText:
            'Your data will be forwarded to Lagerbox Holding GmbH, Hauptverwaltung Hanauer Landstraße 314, 60314 Frankfurt am Main ("Lagerbox") for the purpose of contacting and advising you (e-mail or telephone)',
          backButtonText: 'Back',
          submitButtonText: 'Send request',
          city: {
            label: 'Desired location *',
            placeholder: '- Select location -',
          },
          salutation: {
            label: 'Salutation',
            options: {
              female: 'Ms',
              male: 'Mr.',
            },
          },
          firstName: {
            label: 'first name *',
            placeholder: '',
          },
          lastName: {
            label: 'Last name *',
            placeholder: '',
          },
          email: {
            label: 'Email *',
            placeholder: '',
          },
          phoneNumber: {
            label: 'Phone number *',
            placeholder: '',
          },
          description: {
            label: 'Message',
            placeholder: 'Write a message....',
          },
        },
        linkButton: 'Continue with 5 % discount',
        isEntitledLinkButton: 'Request a non-binding offer',
      },
    },
    rentLegal: {
      headline: 'Tenancy law advice',
      modal: {
        faq: {},
        headline: 'Tenancy law advice',
        image: 'New building in the sunshine',
        overview: {
          paragraph1: "Support with legal questions from AXA Assistance's tenancy law advice",
          paragraph2:
            "Whether it's excessive rent demands or noise pollution from the neighborhood? With tenancy law advice from AXA Assistance, you will receive initial telephone advice on your legal questions.",
          bullet1: 'Advice from certified lawyers from AXA Assistance',
          bullet2: 'Initial telephone advice for up to three tenancy law questions per year',
          bullet3: 'Included in {BuyerPlusLogo}',
          request: {
            keyEmergencyService: {
              title: 'Activation successful',
              text: 'The tenancy law advice was successfully activated.',
              insuranceStatus: {
                title: 'Service active',
                deaktivieren: '(deactivate)',
                kundennummer: 'Your customer number',
                versicherungsnummer: 'Insurance number',
                anschrift: 'Your address',
                kontaktdaten: 'Emergency contact details',
                dokumente: 'Documents',
                cancellationText: 'Are you sure you want to deactivate tenancy law advice?',
                cancellationButton: 'Deactivate',
                cancellationButtonCancel: 'Cancel',
                edit: 'edit',
                customerService: {
                  phoneNumber: '0221 80247 1360',
                  phoneNumberText: ' Available around the clock every day',
                  email: 'immobilienscout24@axa-assistance.de',
                },
              },
              axaFooter: {
                title: 'Have you lost your keys and need help?',
                text: 'AXA tenancy law advice covers costs up to €500.',
                companyName: 'Inter Partner Assistance Service GmbH',
                companyStreet: 'Große Scharmstraße 36',
                companyCity: '15230 Frankfurt (Oder)',
              },
            },
            title: 'Activation required',
            description:
              'You must take out tenancy law advice in advance, free of charge, so that you are covered in an emergency',
            description2: 'The tenancy law advice was successfully activated.',
            customerService: {
              headline: 'Any questions?',
              text: 'LAGERBOX customer service will be happy to help you personally',
              phoneNumber: '0800 / 222 666 999',
              businessHours: 'Mon - Fri 8 a.m. - 9 p.m.',
              businessHoursWeekend: 'Sat 9 a.m. to 5 p.m.',
              email: 'immobilienscout@lagerbox.com',
            },
          },
        },
        howItWorks: {
          image1: 'Police',
          image2: 'scale',
          image3: 'Telephone receiver',
          paragraph1: 'Activate tenancy law advice online in under 2 minutes and receive contact details.',
          paragraph2:
            'If you have a legal problem or legal questions in connection with tenancy and real estate law, contact AXA Assistance by phone or email.',
          paragraph3: 'Receive an initial telephone consultation and obtain a legally sound opinion.',
        },
        form: {
          title:
            'Simply submit the form and you will immediately receive a confirmation email with contact details for tenancy law advice:',
          footerText:
            'I agree that my data will be transmitted to <a href="https://www.axapartners.de/" target="_blank" rel="noreferrer"> AXA Assistance </a> and processed there for the purpose of providing services be used. I further agree that, to the extent that this serves the proper implementation of the insurance matter, AXA Assistance will combine general contract, billing and performance data into common data collections of the insurance group. Further information on how to handle your data can be found <a href=https://www.axapartners.de/datenschutz" target="_blank" rel="noreferrer"> here </a>.',
          cancelButtonText: 'Cancel',
          submitButtonText: 'Activate now',
          saveButtonText: 'Save',
          backButtonText: 'Back',
          city: {
            label: 'City',
            placeholder: '',
          },
          salutation: {
            label: 'Salutation',
            options: {
              female: 'Ms',
              male: 'Mr.',
            },
          },
          firstName: {
            label: 'First name',
            placeholder: '',
          },
          lastName: {
            label: 'Last name',
            placeholder: '',
          },
          street: {
            label: 'Street',
            placeholder: '',
          },
          houseNumber: {
            label: 'House number',
            placeholder: '',
          },
          postcode: {
            label: 'Postal code',
            placeholder: '',
          },
        },
        linkButton: 'Discover Wohnen+',
        activeButton: 'Activate tenancy law advice',
      },
    },
    documents: {
      headlines: {
        profileAndDocuments: 'Profile & Documents',
        applicantFolder: 'Applicant folder',
      },
      modal: {
        faq: {},
      },
    },
    opportunityCheck: {
      headline: 'Opportunities Check',
      modal: {
        image: 'Mobile phone with opportunity check preview',
        overview: {
          paragraph1: "Good prospects? We'll show you your chances transparently.",
          paragraph2:
            'How many interested people are there really? Does your budget fit the property? Find out exclusively and in advance what your chances are of getting your dream property and save valuable time.',
        },
        howItWorks: {
          paragraph:
            'With the chances check in the expose, we calculate your chances of getting the property ad. This is calculated from demand and prospect analysis.',
          section1: {
            title: 'Ad Demand',
            paragraph:
              'We show you how long the ad has been online, how many people have seen it and how many are interested in the property.',
            image: 'Ad demand on mobile',
          },
          section2: {
            title: 'Stakeholder analysis',
            paragraph:
              'We give you information about your competition, i.e. people who have put the property on their watch list or contacted it. Use the knowledge advantage when contacting the providers!',
            image: 'Prospect analysis on mobile phone',
          },
        },
        faq: {
          item0: {
            question: 'How do the results relate to my chances?',
            answer:
              'The Opportunity Check gives you concrete figures about how many and which people have sent a contact request for the respective property. You tend to have better chances if you are among the first to contact a newly listed property.{br}{br}Owners and brokers also expect a higher probability of realization with Plus members than with members without Plus. When it comes to the characteristics of the prospective buyer, what is often most important, especially for owners, is how well they fit the property. Here you can score points: For example, are the living space and surroundings more suitable for a big city single or a young family?',
          },
          item1: {
            question:
              'Is it still worth contacting an ad that has already received a large number of contact requests?',
            answer:
              "That depends very much on the individual case. Although the probability that an object will be successfully sold increases with increasing time and the number of contact inquiries, purchasing processes can take a very long time. There are many reasons why the purchase does not go through, for example because the current owners have very precise ideas about the buyers. So don't be put off by a high number of contact requests.",
          },
          item2: {
            question: 'Where does the data listed come from?',
            answer:
              'The statistics are based on the anonymized information of all contact inquiries about the respective property that were received via our portal.',
          },
          item3: {
            question:
              'Does the Opportunity Check still offer me an advantage if the majority of users already have Plus?',
            answer:
              'The opportunities check helps you as a Plus member to know your competition and thus better assess your chances of getting the property. Suchen+ for buy members represent a small proportion of ImmoScout24 users, so you still have the advantage over the majority.',
          },
        },
      },
    },
    autoContactAgent: {
      headline: 'Application assistant',
      modal: {
        image: 'Illustration of a person using a smartphone',
        paragraph1: 'With the application assistant, you decide what you are looking for – we take care of the rest.',
        paragraph2:
          'The application assistant continuously checks new listings that match your search criteria and automatically sends enquiries for you. This gives you a head start as soon as a suitable apartment goes online.',
        paragraph3: 'You remain in full control and can adjust or pause your search at any time.',
        learnMore: 'Learn more',
      },
    },
    opportunityCheckMieterPlus: {
      headline: 'Opportunities Check',
      modal: {
        image: 'Mobile phone with opportunity check preview',
        overview: {
          paragraph1: "Good prospects? We'll show you your chances transparently.",
          point1: 'Analysis of demand',
          point2: 'Your profile compared to the preferences of the landlords',
          point3: 'Information about your competition',
          linkButton: 'Discover Suchen+',
          activeMieterPlus: 'Included in {MieterPlusLogo}',
        },
        linkButton: 'Discover Suchen+',
        faq: {},
      },
    },
    exclusiveListings: {
      headline: 'Exclusive Ads',
      modal: {
        image: 'Mobile phone with exclusive ad preview',
        overview: {
          paragraph1:
            "Exclusive ads' come from private owners and can be contacted first by you as a Plus member in the first 72 hours. This will give you a head start on others.",
          paragraph2:
            'The exclusive ads automatically appear to you like all other ads when searching or in notifications. They are not marked separately.',
          activeKaeuferPlus: 'Included in {BuyerPlusLogo}',
        },
        linkButton: 'Discover Suchen+',
        faq: {
          item0: {
            question: 'How big is my advantage if my competition consists of Plus users?',
            answer:
              "From discussions with our providers, we know that the vast majority select suitable candidates from the first inquiries.<br/><br/>Suchen+ for buy members represent a small part of ImmoScout24's users. Due to the restriction to Plus Members during the first 72 hours already have an advantage over other interested parties without a plus. Among interested people with Plus membership, what is often crucial is how well the interested parties fit the property based on the seller's ideas (e.g. price expectations, accessibility, perceived interest).",
          },
          item1: {
            question: 'What information is accessible to users without membership?',
            answer:
              'Users without Plus membership can see the exposé including all information available for the property such as price, area, number of rooms and pictures. However, you will not have the opportunity to contact the person making the offer within the first 72 hours. This remains reserved for Suchen+ for buy members.',
          },
          item2: {
            question: 'Are exclusive advertisements only available on ImmoScout24?',
            answer:
              'The vast majority of exclusive advertisements can only be found on ImmoScout24. We cannot always completely rule out the possibility of advertisers also advertising on other sites, but we try to provide incentives accordingly.',
          },
          item3: {
            question: 'How many exclusive ads are available to me?',
            answer:
              'Exclusive advertisements are available throughout Germany. The offer may vary over time and region.',
          },
          item4: {
            question: 'What advantage do providers have from exclusive ads?',
            answer:
              'A heated market situation in many areas means that providers can receive a lot of inquiries for their properties. Limiting it to Plus members within the first 72 hours can help to estimate the flow of inquiries, keep it manageable and focus on searchers with a high probability of purchasing.',
          },
          item5: {
            question: 'How do the "Exclusive Ads" differ from the "Exclusive Advance Sales"?',
            answer:
              '"Exclusive advertisements" come from private owners and can only be contacted by Plus members for the first 72 hours.<br/><br/>Ads in "Exclusive pre-sales" come from brokers and are only available to Plus for the first 24 hours -Members can be contacted. In addition, fewer details about the property on offer are visible with these advertisements. ',
          },
        },
      },
    },
    exclusiveListingsMieterPlus: {
      headline: 'Exclusive Ads',
      modal: {
        image: 'Mobile phone with exclusive ad preview',
        overview: {
          paragraph1:
            "Exclusive ads' can be contacted first by you as a Plus member in the first 48 hours. This will give you a head start over other competitors.",
          activeMieterPlus: 'Included in {MieterPlusLogo}',
        },
        linkButton: 'Discover Suchen+',
        faq: {
          item0: {
            question: 'How big is my advantage if my competition consists of Plus users?',
            answer:
              "From conversations with our property providers, we know that the vast majority select suitable candidates from the first inquiries.<br/><br/>Suchen+ for rent members make up a small proportion of ImmoScout24 users. Restricting contact to Plus members during the first 72 hours therefore gives you an advantage over interested parties without Suchen+. Among interested Plus members, the deciding factor is often how well they match the property and the seller's expectations, such as price expectations, availability and perceived interest.",
          },
          item1: {
            question: 'What information is accessible to users without membership?',
            answer:
              'Users without a Plus membership can view the listing with all available property information, such as price, floor area, number of rooms and pictures. However, they cannot contact the provider within the first 72 hours. During this time, contact is reserved for Suchen+ for rent members.',
          },
          item2: {
            question: 'Are exclusive advertisements only available on ImmoScout24?',
            answer:
              'The vast majority of exclusive advertisements can only be found on ImmoScout24. We cannot always completely rule out the possibility of advertisers also advertising on other sites, but we try to provide incentives accordingly.',
          },
          item3: {
            question: 'How many exclusive listings are available to me?',
            answer:
              'Exclusive advertisements are available throughout Germany. The offer may vary over time and region.',
          },
          item4: {
            question: 'What benefits do exclusive listings offer providers?',
            answer:
              'A competitive market in many areas can result in providers receiving many inquiries about their properties. Restricting inquiries to Plus members during the first 72 hours can help providers assess and manage the volume of inquiries and focus on people with a high likelihood of renting.',
          },
        },
      },
    },
    firstInInbox: {
      headline: 'Up in the mailbox',
      modal: {
        image: 'Smartphone display shows provider list',
        overview:
          "Your messages to the person making the offer will always be displayed at the top of ImmoScout24's inbox and your profile will be clearly marked as a Plus member.",
        faq: {
          item0: {
            question: "Does sorting at the top of the offeror's mailbox actually offer an advantage for me?",
            answer:
              "From discussions with our providers, we know that the vast majority select suitable candidates from the first inquiries. BuyerPlus members represent a small proportion of ImmoScout24 users. The restriction to Plus members during the first 24 to 72 hours already gives an advantage over other interested parties without Plus. Within the interested Plus members, the seller's ideas about the criteria (e.g. price expectations, accessibility, perceived interest) of the future buyers often decide whether they fit the property.",
          },
          item1: {
            question:
              "How will my contact request appear in the provider's inbox compared to users without Plus membership?",
            answer:
              "Inquiries from Plus members appear in the offeror's inbox at ImmoScout24 above those of users without Plus. Within the inquiring Plus members, the requests are sorted according to the time they were received in the inbox with the most recent messages at the top. In addition, Plus members are separately identified as such with a plus symbol.",
          },
          item2: {
            question: 'Why would providers prefer Plus members over users without Plus membership?',
            answer:
              "Our users visit ImmoScout24 in different life situations and with different motivations. Some first want to get a feel for the market or how they want to live, how viewings work or are unsure whether they want to buy at all. This tends to be less common among BuyerPlus members. From a broker's perspective, these are more likely to be characterized by a high level of interest and a higher probability of realization, which can save them time and effort.",
          },
        },
      },
    },
    firstInInboxMieterPlus: {
      headline: 'Up in the mailbox',
      modal: {
        image: 'Smartphone display shows provider list',
        overview:
          'Your messages to providers are always displayed at the top of the ImmoScout24 inbox and your profile is clearly marked as a Plus member.',
        linkButton: 'Discover Suchen+',
        activeMieterPlus: 'Included in {MieterPlusLogo}',
        faq: {},
      },
    },
    schufaCheck: {
      headline: 'SCHUFA credit check',
      modal: {
        image: 'Hands hand over SCHUFA credit check document',
        overview: {
          paragraph: 'Original SCHUFA credit check, which can be updated once a month by Plus members.',
          bullet1: "Immediately download online - even when you're on the move",
          bullet2: 'Order once and send it to several providers at the same time',
          bullet3: 'Increase your chance of getting your dream home',
          bullet4: 'Monthly update included in {BuyerPlusLogo}',
        },
        howItWorks: {
          image1: 'Paper and Pen',
          image2: 'Opened envelope',
          image3: 'Download icon',
          image4: 'Coin',
          paragraph1: 'Include name, address and date of birth in the online form.',
          paragraph2: 'Document received by mail within 3-5 business days.',
          paragraph3: '…or simply download directly through online verification via ID document or online banking.',
          paragraph4: 'Monthly update of the original SCHUFA credit check included in {BuyerPlusLogo}.',
        },
        deletionPeriod: {
          entryType: 'Type of entry',
          deletionPeriod: 'deletion period',
          wrongEntries: 'Wrong entries',
          deletedImmediately: 'Immediate deletion',
          loans: 'loans',
          threeYearsAfterRepayment: 'Three years after repayment',
          debtCollection: 'Debt collection/reminder procedure',
          threeYearsAfterCompletion: 'Three years after completion',
          affidavit: 'sworn affirmation',
          threeYearsAfterExpiry: 'Three years after expiry',
          bankruptcyProceedings: 'Insolvency Proceedings',
          tenYearsUntilCompletion: 'Ten years until complete completion',
        },
        faqHeadline1: 'SCHUFA credit check',
        faqHeadline2: 'General Questions',
        faq: {
          item0: {
            question: 'What does the SCHUFA credit check offer?',
            answer:
              'The credit check is the official credit report from SCHUFA (cooperation with SCHUFA). The authenticity of the document can be checked using the verification code. This allows you to prove your basic solvency. SCHUFA information is therefore desired by many providers.',
          },
          item1: {
            question: 'How secure is the SCHUFA credit check?',
            answer:
              'Your information will only be used to create the information. The data is transferred securely via SSL encryption.',
          },
          item2: {
            question: 'What happens to my data?',
            answer:
              'Your information will only be used to create the information. The data is transferred securely via SSL encryption.',
          },
          item3: {
            question: 'How do I receive the SCHUFA credit check?',
            answer:
              'The creation time is usually only a few seconds. You will usually receive your credit check immediately after placing your order as an online download or by post.',
          },
          item4: {
            question: 'How long does it take to send the SCHUFA credit check online?',
            answer:
              'You will receive the SCHUFA credit check directly after your order as an online download or by post. The creation time is usually only a few seconds if you have chosen the “Online PDF” shipping method and the verification process (finAPI - online banking or WebID - ID card or passport) has been carried out successfully.',
          },
          item5: {
            question: 'How long does it take to receive SCHUFA information by post?',
            answer:
              'If you use the “letter post” shipping method, you will usually receive the document 1 to 3 days after ordering.',
          },
          item6: {
            question: 'Can I also buy the SCHUFA credit check with a foreign ID document?',
            answer:
              'The online download of the SCHUFA credit check and the associated identification is only possible with an online banking account. If you decide to have your SCHUFA credit check sent by post, you must have a registration address in Germany. Unfortunately, sending by post abroad is not possible.',
          },
          item7: {
            question: 'What should I do if identity verification fails?',
            answer:
              'If your identity cannot be established beyond doubt, we ask you to opt for postal delivery. Please understand that the protection of your personal data has priority.',
          },
          item8: {
            question: 'How can the provider check the accuracy of the data in the SCHUFA credit check?',
            answer:
              'The provider can check the data using a so-called verification code. The verification code is printed on every SCHUFA credit check. This code can be used to check whether the corresponding result document belongs to a valid SCHUFA credit check.',
          },
          item9: {
            question: 'What is SCHUFA?',
            answer:
              'The abbreviation SCHUFA stands for “Protection Association for General Credit Protection”. The basic tasks and principles of SCHUFA have not changed since it was founded in 1927: The goal is still to protect the lending institutions from loan defaults - as well as to protect borrowers from over-indebtedness. This is done by networking a wide range of contractual partners who pass on information about your payment behavior to SCHUFA.',
          },
          item10: {
            question: 'What do I need SCHUFA for?',
            answer: 'With the SCHUFA credit check you show the provider your ability to pay.',
          },
          item11: {
            question: 'What does the SCHUFA report say?',
            answer:
              'The participating contractual partners exchange payment information with each other via SCHUFA.{br}' +
              '{br}' +
              'The SCHUFA information contains, for example, the following information:' +
              '<ul>' +
              '<li>Personal data (name, address, date of birth, place of birth)</li>' +
              '<li>Contracts & accounts: current accounts, credit cards, installment loans, leasing contracts, telephone contracts, guarantees</li>' +
              '<li>Information on the reliability of the payment: e.g. payment disruptions, information on insolvency proceedings and debtor directory entries</li>' +
              '</ul>' +
              '{br}' +
              '<strong>Not</strong> be noted:' +
              '<ul>' +
              '<li>Account balances</li>' +
              '<li>Income</li>' +
              '<li>Investments</li>' +
              '</ul>',
          },
          item12: {
            question: 'When will I receive a SCHUFA entry?',
            answer:
              "In principle, companies are allowed to report data to SCHUFA and request SCHUFA information if they give their customers loans. This doesn’t just mean the loans issued by banks. According to SCHUFA's understanding, the delivery of goods and services that are only paid for by customers at a later date are also considered to be the granting of loans. This also includes telecommunications companies, mail order businesses and energy supply.",
          },
          item13: {
            question: 'When will SCHUFA entries be deleted again?',
            answer:
              'SCHUFA only stores information about people for a certain period of time. The main criterion for determining this time is necessity. SCHUFA has set standard deadlines for examining the necessity of further storage or deletion of personal data. Thereafter, the basic storage period for personal data is three years to the day after its completion.{br}' +
              '{br}' +
              'Different from this, the following are deleted, for example:' +
              '<ul>' +
              '<li>Information about inquiries after twelve months, accurate to the day</li>' +
              '<li>Information about trouble-free contract data about accounts that are documented without the justified claim (e.g. current accounts, credit cards, telecommunications accounts or energy accounts), information about contracts for which the evidence check is required by law (e.g. seizure protection accounts, basic accounts) as well Guarantees and commercial accounts maintained on credit immediately upon notice of termination.</li>' +
              '<li>Data from the debtor lists of the central enforcement courts after three years, accurate to the day, but early if SCHUFA is proven to have been deleted by the central enforcement court.</li>' +
              '<li>Information about consumer/insolvency proceedings or residual debt discharge proceedings exactly three years after the end of the insolvency proceedings or the granting of the residual debt discharge. In special individual cases, earlier deletion can also take place.</li>' +
              '<li>Information about the rejection of an insolvency application due to lack of assets, the lifting of the security measures or the denial of discharge of residual debts on a daily basis after three years.</li>' +
              '<li>Personal prior addresses are stored for three years to the day; The necessity of continued storage for a further three years will then be examined. They will then be deleted on a daily basis, unless long-term storage is required for identification purposes.</li>' +
              '</ul>' +
              '{SchufaDeletionPeriodTable}',
          },
          item14: {
            question: 'SCHUFA: What does scoring mean?',
            answer:
              'Scoring is a process in which a forecast is created from a quantity of collected data.{br}{br}' +
              "The more data available, the better the predictions. With Germany's leading range of credit agency and information services for companies and consumers, SCHUFA has a unique database with credit-relevant information on people and companies.{br}{br}" +
              'Score values that SCHUFA calculates for consumers are based on the data stored by SCHUFA about the person. The information stored includes the number and type of credit activities, any payment defaults or information about how long you have had experience with credit transactions.{br}{br}' +
              'The <strong>SCHUFA basic score</strong> is created independently of the industry and is intended to say something generally about how likely it is that someone will complete a transaction in accordance with the contract. The base score is a percentage that is updated every three months. For example, with a SCHUFA base score of 95, a low to manageable risk of default is assumed.{br}{br}' +
              'There are <strong>industry-specific scores</strong> because you have to make a different forecast for the probability of someone paying a bill than the probability of someone paying back a personal loan. According to SCHUFA, the industry-specific scorings are not stored but are calculated on a daily basis.',
          },
        },
        plusLinkButton: 'To the SCHUFA credit check',
        basicLinkButton1: 'Create for €29.95',
        basicLinkButton2: 'Create with Suchen+',
      },
    },
    schufaCheckMieterPlus: {
      headline: 'credit report',
      modal: {
        faq: {},
        image: 'Hands hand over SCHUFA credit check document',
        overview: {
          paragraph: 'Original SCHUFA credit check, which can be updated once a month by Plus members.',
          bullet1: "Immediately download online - even when you're on the go",
          bullet2: 'Order once and send it to several landlords',
          bullet3: 'Increase your chance of getting your dream home',
          bullet4: 'Update monthly with {MieterPlusLogo}',
          bullet4alt: 'Activate {MieterPlusLogo} and update SCHUFA monthly',
          notActive: 'Out of date',
          paragraph2: 'Your SCHUFA lost its validity on {formattedDate}.',
          activateFree: 'Update now for free',
          activateNow: 'Update Now',
          activeUntilDate: 'Valid until {formattedDate}',
          verificationCode: 'Verification code : ',
          linkButton: 'Discover Suchen+ for rent',
        },
        howItWorks: {
          image1: 'Paper and Pen',
          image2: 'Opened envelope',
          image3: 'Download icon',
          paragraph1: 'Include name, address and date of birth in the online form.',
          paragraph2: 'Document received by mail within 3-5 business days.',
          paragraph3: '…or simply download directly through online verification via ID document or online banking.',
        },
        ctaButtonSolvencyDocuments: 'Go to credit report',
        ctaButtonNoSolvencyDocuments: 'To the SCHUFA credit check',
      },
      schufaModal: {
        modalTitle: 'SCHUFA credit check',
        headline: 'Many landlords require an official credit report',
        description: [
          'Accepted by landlords',
          'Certificate to share with your landlord (valid for 2 months)',
          'Create and download in 3 minutes',
        ],
        schufaIncluded: 'For Suchen+ for rent members ',
        is24SolvencyIncluded: {
          prefix: 'Additional Suchen+ for rent offer: ',
          link: 'ImmoScout24 credit report',
        },
        schufaOriginalPrice: '29,95 €',
        schufaDiscounted: ' only {discountedPrice} €',
        create: 'Create now',
        link: 'ImmoScout24 credit report',
        alreadyBought: {
          text: 'Already ordered? ',
          link: 'View now',
        },
        closePreview: 'Minimize',
      },
      solvencyChoice: {
        solvency: {
          title: 'credit report',
          schufa: {
            title: 'SCHUFA credit check',
          },
        },
        title: 'ImmoScout24 credit report',
        subtitle: 'ImmoScout24 credit report',
        goToSummary: 'View detailed result',
        description: [
          'Accepted by landlords',
          'Certificate to share with your landlord (valid for 3 months)',
          'Clear result (only visible to you)',
        ],
        button: {
          addMoreSolvency: 'Create another credit report',
          closePreview: 'Minimize',
          create: 'Create in 3 minutes',
        },
        headline: 'Many landlords require an official credit report',
        alreadyBought: {
          text: 'Already ordered? ',
          link: 'View now',
        },
        schufaIncluded: {
          prefix: 'Also included: ',
          link: 'Create SCHUFA credit check',
        },
        schufaDiscounted: {
          prefix: 'Additional Suchen+ for rent offer: ',
          link: 'SCHUFA credit check for {price}',
        },
        schufaFullPrice: {
          prefix: '',
          link: 'SCHUFA credit check for a one-time payment of {price}, including VAT',
        },
        is24SolvencyIncluded: '<b>Included</b> for Suchen+ for rent members',
        addByVerificationCode: {
          title: 'Enter your verification code here',
          form: {
            verificationCode: {
              label: 'Verification code',
              placeholder: 'e.g. XXXX-XXXX-XXXXX',
              validation: {
                invalid: 'The verification code does not match the format "XXXX-XXXX-XXXXX".',
                missing: 'The verification code is invalid.',
              },
            },
            firstName: {
              label: 'First name',
              validation: {
                missing: 'Please enter your first name.',
                capitalized: 'Please check capitalization.',
                invalid:
                  'Your first name contains invalid characters. Please use only letters (a-z,ä,ö,ü,ß) and hyphens (-).',
                short: 'Please enter at least 2 letters.',
              },
            },
            lastName: {
              label: 'Last name',
              validation: {
                missing: 'Please enter your last name.',
                capitalized: 'Please check capitalization.',
                invalid:
                  'Your last name contains invalid characters. Please use only letters (a-z,ä,ö,ü,ß) and hyphens (-).',
                short: 'Please enter at least 2 letters.',
              },
            },
          },
          error: {
            notFound: {
              title: 'Result',
              message:
                'The code could not be verified. Please use the same spelling of your first and last name as on your document and check that the corresponding verification code is correct and still valid. Expired verification codes are not accepted.',
            },
            technical: {
              title: 'Technical error',
              message: 'Unfortunately, a technical error occurred. Please try again later.',
            },
          },
          backButton: 'Back',
          submit: {
            label: 'Done',
          },
        },
      },
    },
    applicationPackage: {
      headline: 'Introduction folder',
      modal: {
        image: 'Introduction folder is presented',
        overview: {
          paragraph:
            "ImmoScout24's introduction folder contains documents that you will need to apply for your new home. All documents can be created online within a few minutes.",
          bullet1:
            'Automatically create and update all documents important for the application - without any paperwork',
          bullet2: 'In high-quality design - digital or for printing',
          bullet3: 'Offers trust the ImmoScout24 introduction folder',
          bullet4: 'Included in {BuyerPlusLogo}',
          slide1: 'Cover page',
          slide2: 'Self-disclosure (1 of 2)',
          slide3: 'Self-disclosure (2 of 2)',
          slide4: 'Buyer Certificate',
          slide5: 'SCHUFA credit check',
          indicator: 'indicator',
        },
        howItWorks: {
          image1: 'Mobile phone with profile view',
          image2: 'Introduction folder on paper and digital',
          image3: 'Contract conclusion',
          paragraph1: 'Automatically create or upload application documents in your profile within a few minutes.',
          paragraph2: 'With one click, a complete introduction folder is created from the documents.',
          paragraph3:
            'Download the presentation folder as a PDF, print it out, or attach it digitally to a message with just one click.',
        },
        faq: {
          item0: {
            question: 'Which documents can I add to my introduction folder?',
            answer:
              'You can add all documents to your introduction folder that could convince the offerers to consider you as a buyer. These include, among others:' +
              '<ul>' +
              '<li>Self-disclosure, which contains the most important data about you</li>' +
              "<li>SCHUFA credit check to show the offeror's ability to pay</li>" +
              '<li>Financing certificate to check and prove your ability to finance up to a certain amount in advance</li>' +
              '<li>You can add other relevant documents (such as: financing confirmation, proof of equity, etc.) under My Documents</li>' +
              '</ul>',
          },
          item1: {
            question: 'Can I also use the introduction folder with another person?',
            answer:
              "You can also use the introduction folder for two or more people. You can easily add other people's documents via 'My Documents'.",
          },
          item2: {
            question: 'Can I print out the introduction folder afterwards?',
            answer:
              "As a BuyerPlus member, you can download the presentation folder as a PDF. You can generate the PDF in the menu item <BuyerReportPageLink>Profile & Documents</BuyerReportPageLink> using the 'Download' button.",
          },
        },
        linkButtonWithMieterPlus: 'To my introduction folder',
        linkButtonWithoutMieterPlus: 'Discover Suchen+',
      },
    },
    applicationPackageMieterPlus: {
      headlineOne: 'Applicant folder',
      headlineTwo: 'Profile & Documents',
      modal: {
        image: 'Applicant folder is presented',
        overview: {
          paragraph:
            "ImmoScout24's application folder contains all the documents you need to apply for your new home. All documents can be created online within a few minutes.",
          bullet1:
            'Automatically create and update all documents important for the application - without any paperwork',
          bullet2: 'In high-quality design - digital or for printing',
          bullet3: 'Providers trust the ImmoScout24 applicant folder',
          bullet4: 'Included in {MieterPlusLogo}',
          slide1: 'Cover page',
          slide2: 'Self-disclosure (1 of 2)',
          slide3: 'Self-disclosure (2 of 2)',
          slide4: 'SCHUFA credit check',
          slide5: 'Proof of Identity',
          slide6: 'Proof of income',
          slide7: 'Proof of rent payment (1 of 2)',
          slide8: 'Proof of rent payment (2 of 2)',
          slide9: 'My Documents',
          indicator: 'indicator',
          alternateText: {
            bigText: 'Your profile combines all important data about you.',
            smallTextOne:
              'With your personal information, contact details, wishes and relevant documents, such as SCHUFA credit check and self-disclosure, providers get a comprehensive impression of you.',
            smallTextTwo:
              'And with the exclusive and professional Suchen+ for rent applicant folder you can create your income, rent payment and identity documents with just a few clicks - all digitally, without scanning and paper chaos.',
            smallTextThree:
              'This is how you present yourself in the best possible way to your future landlords and make their work easier.',
          },
        },
        howItWorks: {
          image1: 'Mobile phone with profile view',
          image2: 'Introduction folder on paper and digital',
          image3: 'Contract conclusion',
          paragraph1: 'Automatically create or upload application documents in your profile within a few minutes.',
          paragraph2: 'With one click, a complete applicant folder is created from the documents.',
          paragraph3:
            'Download the applicant folder as a PDF, print it out, or attach it digitally to a message with just one click.',
        },
        faq: {},
        linkButtonWithMieterPlus: 'To my applicant folder',
        linkButtonWithoutMieterPlus: 'To my profile',
        linkDiscoverMieterPlus: 'Discover Suchen+ for rent',
      },
    },
    valuation: {
      headline: 'Property Valuation',
      modal: {
        image: 'Smartphone display shows house and valuation data',
        overview: {
          paragraph1:
            'You have found an attractive property and now want to quickly find out whether the sales price corresponds to the current market price?',
          paragraph2:
            'So that you can go into the price negotiations with the seller in a safe manner, we use extensive data to determine the current market value and also how the value could develop in the next few years.',
          bullet1: 'Valuation in a few minutes',
          bullet2: 'Outlook for the next 2 years',
          bullet3: 'Monthly quota',
        },
        howItWorks: {
          image1: 'House with value',
          image2: 'Charts',
          image3: 'repeat character',
          paragraph1:
            'With just a few pieces of data you get a current valuation of your property. Every month you can rate up to 5 objects.',
          paragraph2:
            'For each valuation you will receive a detailed view that shows you how the property value is expected to develop over the next 2 years.',
          paragraph3:
            'We check for you every 3 months to see whether the calculated value of the property has changed. In this case you can easily update the value with just one click.',
        },
        faq: {},
        linkButton: 'Rate property',
        overviewButton: 'My Reviews',
        unlockBuyerPlusButton: 'Discover Suchen+',
        contingent: 'You have already completed <b>5 reviews</b> this month. Next month you can do 5 reviews again.',
      },
    },
    realEstateProof: {
      headline: 'DEKRA real estate inspection',
      modal: {
        image: 'Man inspecting building',
        overview: {
          paragraph1: 'Safe house construction through early detection of defects or damage.',
          paragraph2:
            "A neutral expert will help you as the builder to adhere to the project's time and cost framework. DEKRA carries out neutral checks on your new building project after defined construction phases. If defects are identified and eliminated in a timely manner, your project will stay on schedule and this will help ensure that you can move in as planned.",
          bullet1: '15% discount for {BuyerPlusLogo}',
          bullet2: 'Support from DEKRA experts',
          bullet3: 'On-site inspections depending on construction progress',
          bullet4: 'Checking the execution status',
          bullet5: 'Creation of reports with photo documentation',
          bullet6: 'Only for new construction projects',
        },
        howItWorks: {
          image1: 'Paper and Pen',
          image2: 'Calendar',
          image3: 'Person',
          paragraph1:
            'You can request help from DEKRA even before defects in your property make your life difficult. In the next step, provide your contact details and a short description of the problem.',
          paragraph2: 'You will receive suggested appointments for a non-binding consultation within a few days.',
          paragraph3:
            'In a personal conversation, the problem will be discussed, your needs will be discussed and an offer will be created including the exclusive discount of 15%.',
        },
        faqHeadline1: 'Use cases',
        faqHeadline2: 'Costs & Process',
        faq: {
          item0: {
            question: 'In which cases would I as a buyer make use of this service?',
            answer:
              'As a builder, you usually have to get several partners on board with new, conversion or renovation projects.{br}' +
              'Mistakes are inevitable - some of them only become painfully noticeable after years. Experts from DEKRA document the state of execution of the construction work in inspections timed to the progress of construction.{br}' +
              'The aim is to identify annoying and costly execution errors at an early stage and to correct them in good time during the construction phase.',
          },
          item1: {
            question: 'Is a real estate inspection also worthwhile for existing properties?',
            answer:
              'The real estate test is only used for new construction projects. For existing properties, we recommend the condition assessment for existing buildings.',
          },
          item2: {
            question: 'Can I only use this service for new construction projects?',
            answer:
              'Yes, the real estate inspection is a construction-related inspection. The neutral experts from DEKRA check and document the execution status of the work, phase by construction phase. If it is an existing property, we recommend assessing the condition of buildings and apartments.',
          },
          item3: {
            question: 'Can I only use this service if there are existing defects, or also for precautionary purposes?',
            answer:
              'The real estate inspection is a preventive construction monitoring in order to identify possible execution errors in the construction work at an early stage. If damage has already occurred, we recommend the DEKRA building damage report.',
          },
          item4: {
            question:
              'What is the difference between the "DEKRA real estate inspection" and the "DEKRA building damage report"?',
            answer:
              'The DEKRA real estate inspection is a construction monitoring service in which possible execution errors or defects in the construction work are identified and documented at an early stage. This means they can often be removed without much effort.{br}' +
              'The DEKRA structural damage report is used if a specific structural damage (e.g. moisture damage) has occurred due to a defect and needs to be assessed. The damage can then be eliminated by specifically identifying the cause.',
          },
          item5: {
            question: 'How much does a real estate inspection usually cost?',
            answer:
              'As each exam is very individual and depends on how large the scope of the exam is, no exact information can be given here. However, creating an offer is free of charge and does not constitute a binding contract.',
          },
          item6: {
            question: 'Is creating an offer free of charge?',
            answer: 'Yes, creating an offer is free of charge and non-binding.',
          },
          item7: {
            question: 'How can I use this service?',
            answer: 'You can find more information about the process under the “How it works” tab.',
          },
          item8: {
            question: 'What does DEKRA do?',
            answer:
              'The DEKRA construction experts check your property in all important phases:' +
              '<ul>' +
              '<li>Accompanying construction, so that possible execution errors are identified at an early stage</li>' +
              '<li>During the final inspection, which you accompany as a neutral third party</li>' +
              '<li>Before the warranty expires, so that you do not have to have any construction or warranty defects remedied later at your own expense</li>' +
              '</ul>' +
              'You will receive further information about DEKRA services when DEKRA prepares the offer.',
          },
          item9: {
            question: 'Can I also upload images directly for testing?',
            answer:
              'No. In the first step, we hand over the interest in a real estate inspection or the creation of an offer to DEKRA. In the following steps, DEKRA then decides what is needed to create an offer.',
          },
          item10: {
            question: 'What happens to my transmitted data?',
            answer:
              'Your local DEKRA branch will contact you with all the details in order to create an offer and coordinate the appointment on site.{br}' +
              'The processing of personal data for pre-contractual or contractual purposes is based on Art. 6 Para. 1 GDPR.{br}' +
              'Storage period: If necessary, we process and store your personal data for the duration of our business relationship. In addition, we are subject to retention and documentation obligations arising from the Commercial Code and the Tax Code. Ultimately, the storage period is also determined by statutory limitation periods.',
          },
          item11: {
            question: 'What benefits do I get as a Plus member, apart from the discount?',
            answer: 'Plus members receive a 15% discount on the current DEKRA fee tables.',
          },
        },
        linkButton: 'Request a quote',
      },
    },
    realEstateDamageReport: {
      headline: 'DEKRA building damage report',
      modal: {
        image: 'Man on construction site looking at plan',
        overview: {
          subHeading: 'Expert opinion and recommendation for repairing damage.',
          paragraph:
            'If damage occurs to the building, quick and careful action is required. A structural damage report by DEKRA experts gets to the bottom of the causes and documents the extent. The possible scope of services also includes the description of necessary repair measures and the determination of costs.',
          bullet1: '15% discount for {BuyerPlusLogo}',
          bullet2: 'On-site inspection with damage assessment',
          bullet3: 'Assessment of the extent of damage and the cause of damage',
          bullet4: 'Description of repair measures',
          bullet5: 'Optional cost estimate',
        },
        howItWorks: {
          image1: 'Two sheets of paper and a pen',
          image2: 'Calendar with ticks',
          image3: 'Suit wearer',
          paragraph1:
            'Have you discovered damage to your property and need professional support? Then you can request help from DEKRA. In the next step, provide your contact details and a short description of the problem.',
          paragraph2: 'You will receive suggested appointments for a non-binding consultation within a few days.',
          paragraph3:
            'In a personal conversation, the problem will be discussed, your needs will be discussed and an offer will be created including the exclusive discount of 15%.',
        },
        faqHeadline1: 'use cases',
        faqHeadline2: 'Costs and process',
        faq: {
          item0: {
            question: 'In which cases would I make use of this service as a buyer?',
            answer:
              'In the event of structural damage or defects in the building - for example due to mold or moisture - a quick and precise investigation is essential. The Dekra experts will determine the cause of the damage for you, suitable ways to rectify the damage and the associated costs',
          },
          item1: {
            question: 'Is a building damage survey also worthwhile for new buildings?',
            answer:
              'A building damage survey is worthwhile both in the construction phase, for new buildings, and for existing buildings. No matter in which phase of the building construction or service life a damage/defect occurs, a building damage report can be worthwhile. A DEKRA building damage report helps to determine and assess the causes and responsibilities',
          },
          item2: {
            question: 'Can I also use this service during the construction phase of a new building?',
            answer:
              'A building damage survey is worthwhile both during the construction phase, for new buildings, as well as for existing buildings. No matter in which phase of the building construction or service life a damage/defect occurs, a building damage report can be worthwhile. A DEKRA building damage report helps to determine and assess the causes and responsibilities',
          },
          item3: {
            question: 'Can I only use this service if there are existing defects, or also for precautionary purposes?',
            answer:
              'Yes, the structural damage report is an assessment{br}' +
              'Structural damage/defects that have occurred in your house or apartment.{br}' +
              'The DEKRA property inspection is recommended as a precautionary measure.',
          },
          item4: {
            question:
              'What is the difference between the "DEKRA real estate inspection" and the "DEKRA building damage report"?',
            answer:
              'The DEKRA real estate inspection is a construction monitoring service in which possible execution errors or defects in the construction work are identified and documented at an early stage. This means they can often be removed without much effort.{br}' +
              'The DEKRA structural damage report is used if a specific structural damage (e.g. mold or moisture damage) has occurred due to a defect and needs to be assessed. A DEKRA building damage report helps to determine and evaluate causes and responsibilities.',
          },
          item5: {
            question: 'How much does a building damage report usually cost?',
            answer:
              'As each exam is very individual and depends on how large the scope of the exam is, no exact information can be given here. However, creating an offer is free of charge and does not constitute a binding contract.',
          },
          item6: {
            question: 'Is creating an offer free of charge?',
            answer: 'Yes, creating an offer is free of charge.',
          },
          item7: {
            question: 'How can I use this service?',
            answer: 'You can find more information about the process under the “How it works” tab.',
          },
          item8: {
            question: 'What does DEKRA do?',
            answer:
              'DEKRA will provide you with reports on damage/defects to and in buildings, outbuildings as well as all building and property components such as gates, fences and other property borders. The scope of services includes the determination of the cause and responsibilities as well as the description of possible repair measures and the determination of their costs.',
          },
          item9: {
            question: 'Can I also upload images directly for testing?',
            answer:
              'No. In the first step, we hand over the interest in a building damage report or the preparation of an offer to DEKRA. In the following steps, DEKRA then decides what is needed to create an offer.',
          },
          item10: {
            question: 'What happens to my transmitted data?',
            answer:
              'Your local DEKRA branch will contact you with all the details in order to create an offer and coordinate the appointment on site.{br}' +
              'The processing of personal data for pre-contractual or contractual purposes is based on Art. 6 Para. 1 GDPR.{br}' +
              'Storage period: If necessary, we process and store your personal data for the duration of our business relationship. In addition, we are subject to retention and documentation obligations arising from the Commercial Code and the Tax Code. Ultimately, the storage period is also determined by statutory limitation periods.',
          },
          item11: {
            question: 'What benefits do I get as a Plus member, apart from the discount?',
            answer: 'Plus members receive a 15% discount on the current DEKRA fee tables.',
          },
        },
        linkButton: 'Request a quote',
      },
    },
    legalInsurance: {
      headline: 'ARAG Neighborhood Legal Protection',
      modal: {
        headline: 'Neighborhood Legal Protection',
        image: 'New building in the sunshine',
        details: {
          startDate: 'Start date',
          endDate: 'End date',
          explenatory:
            'Your ARAG neighborhood legal protection is activated and available to you for 12 months. After this period, you can extend your coverage with ARAG.',
          active: {
            title: 'Insurance coverage activated!',
            text: 'Your ARAG neighborhood legal protection is activated.',
          },
          legalInsuranceNumberHeader: 'Your contract number',
          legalInsuranceNumber: '11008213767342',
          downloadDocument: 'Download insurance certificate',
          companyData: {
            contactInfo:
              'Do you have a question or want to report a claim? ARAG neighborhood legal protection is here for you. You can find more information in your insurance certificate, available to download.',
            title1: '<b>ARAG SE</b>{br}ARAG Platz 1',
            title2: '40472 Düsseldorf',
            phone: '0211 / 9890 1886',
            email: 'service@arag.de',
          },
        },
        overview: {
          paragraph1: 'Support with legal questions with ARAG Neighborhood Legal Protection',
          paragraph2:
            'If you have any disputes about your property, you have someone at your side. ARAG neighborhood legal protection protects you and is available to you free of charge for one year.',
          bullet1: 'The statutory remuneration of your legal representation',
          bullet2: 'Court costs including expert',
          bullet3: 'Procedural costs of administrative authorities',
          bullet4: 'No deductible',
          bullet5: '1 year in 6 & 12 months {BuyerPlusLogo} included',
        },
        howItWorks: {
          image1: 'Police',
          image2: 'scale',
          image3: 'Telephone receiver',
          paragraph1:
            'After activating ARAG neighborhood legal protection, you will simply receive the contact information for the event of damage and your insurance documents by email.',
          paragraph2:
            'After a 3-month waiting period, full protection begins and you can contact ARAG directly. All you need to do is enter your registered email address and your contract number.',
          paragraph3:
            'If you need legal protection, simply contact ' +
            'ARAG SE at {PhoneNumber} or by email to {EMail}.{Br}' +
            'All you need to do is enter your registered email address and your contract number.',
          phoneNumber: '0211 / 9890 1886',
          eMail: 'service@arag.de',
        },
        faq: {
          item0: {
            question: 'In which cases does legal protection insurance apply?',
            answer:
              'If there are disputes about your property, you have a partner at your side. ARAG Neighborhood Legal Protection protects you, among other things, by covering the costs of:' +
              '<ul>' +
              '<li>the legal remuneration of the lawyer,</li>' +
              '<li>Court costs including experts,</li>' +
              '<li>Procedural costs of administrative authorities</li>' +
              '</ul>' +
              '{br}' +
              'You can download the insurance conditions for ARAG neighborhood legal protection <insuranceAgb>here</insuranceAgb>.',
          },
          item1: {
            question: 'Why is activation required when insurance is part of my Plus membership?',
            answer:
              'As a BuyerPlus member, you have the choice whether you want to use the insurance or not. In addition, we only pass on user data to our partner ARAG where activation has actually taken place. In this way, we also ensure the data security of our users. ',
          },
          item2: {
            question: 'Is there a minimum contract term?',
            answer:
              'As a BuyerPlus member, you can activate ARAG neighborhood legal protection for one year free of charge. The legal protection expires automatically after this year. There is no minimum contract term. ',
          },
          item3: {
            question: 'Does the legal protection insurance extend automatically?',
            answer:
              'No, your ARAG neighborhood legal protection expires after one year and will not be automatically extended.',
          },
          item4: {
            question: 'What happens after my membership is canceled?',
            answer:
              'As soon as you have activated ARAG neighborhood legal protection, it runs for exactly 1 year. If you cancel your BuyerPlus membership during this time, your ARAG neighborhood legal protection will remain unaffected. ',
          },
        },
        linkButton: 'Activate insurance protection',
      },
    },
  },
  modal: {
    tabs: {
      label: 'Feature Description',
      overview: 'Overview',
      howItWorks: 'How It Works',
      faqs: 'FAQs',
      terms: 'Terms of Use',
    },
  },
  welcomeModal: {
    banner: {
      title: 'You can now use all the benefits of {BuyerPlusLogo} !',
      welcomeText: 'Congratulations {FirstName}!',
      welcomeTextNoName: 'Congratulations!',
    },
    livingUpsell: {
      header: {
        part1: 'Your upgrade for more',
        part2: 'Rental Security: Living',
        full: 'Your upgrade for more Rental Security: Living',
      },
      subheader: {
        part1: 'With Tenant',
        part2: 'you get up to {discounts}% welcome discount.',
      },
      explanationText:
        "Whether it's a deposit, rent reduction, or ancillary costs – nothing stresses you out anymore. Because your new rental protection is always there when you need it - starting at {lowestMonthlyCost}€/month.",
      card: {
        perMonth: '/ Month',
        oneTime: 'One-Time',
      },
      buttonText: {
        learnMore: 'Learn More',
        continueToPayment: 'Continue to Payment',
      },
      subscriptionOptions: {
        monthly: {
          title: 'Monthly',
          subtitle: '12 Months Minimum Term',
        },
        yearly: {
          title: '12 Months',
        },
        biYearly: {
          title: '24 Months',
        },
      },
    },
    wohnenUpsell: {
      // TODO: is this needed?
      de: {
        header: 'Dein Upgrade für mehr Miet-Sicherheit: ',
        wohnenPlusS: 'Wohnen+ S',
        subheader: 'Mit Suchen+ für Miete erhältst du bis zu {percentage}% Willkommensrabatt.',
        explanationText:
          'Ob Kaution, Mietminderung oder Nebenkosten - dich stresst nichts mehr. Denn dein neuer Mietschutz ist immer da, wenn du ihn brauchst - schon ab {lowestMonthlyCost}€ / Monat.',
        aragPartnership: 'In Partnerschaft mit ARAG',
        buttonText: {
          otherOptions: 'Mehr erfahren',
          continueToPayment: 'Weiter zur Bezahlung',
        },
        subscriptionOptions: {
          priceTitleMonthly: '<strong>{monthlyPrice} €</strong> / Monat',
          priceTitleYearly: '<strong>{yearlyPrice} €</strong> / Jahr',
          monthly: {
            title: 'Monatlich',
            subtitle: '12 Monate Mindestlaufzeit',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
          yearly: {
            title: 'Jährlich',
            subtitle: '12 Monate Mindestlaufzeit',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
        },
      },
      en: {
        header: 'Protect yourself and your home with ',
        wohnenPlusS: 'Wohnen+ S',
        subheader: 'As a Suchen+ member, you receive up to {percentage}% discount',
        explanationText:
          "Whether it's a deposit, rent increase, or utility costs - nothing stresses you out anymore. Your new tenant protection is always there when you need it - starting from {lowestMonthlyCost} € / month.",
        aragPartnership: 'In partnership with ARAG',
        buttonText: {
          otherOptions: 'Learn more',
          continueToPayment: 'Proceed to checkout',
        },
        subscriptionOptions: {
          priceTitleMonthly: '<strong>{monthlyPrice} €</strong> / month',
          priceTitleYearly: '<strong>{yearlyPrice} €</strong> / year',
          monthly: {
            title: 'Monthly',
            subtitle: '12 Month minimum term',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
          yearly: {
            title: 'Yearly',
            subtitle: '12 Month minimum term',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
        },
      },

      header: 'Protect yourself and your home with ',
      wohnenPlusS: 'Wohnen+ S',
      subheader: 'As a Suchen+ member, you receive up to {percentage}% discount',
      buttonText: {
        otherOptions: 'Other options',
        continueToPayment: 'Secure Wohnen+ S package',
      },
      subscriptionOptions: {
        priceTitleMonthly: '<strong>{monthlyPrice} €</strong> / month',
        priceTitleYearly: '<strong>{yearlyPrice} €</strong> / year',
        monthly: {
          title: 'Monthly',
          subtitle: '12-month minimum term',
          priceBenefit: 'Otherwise <s>{originalPrice} €</s>',
        },
        yearly: {
          title: 'Yearly',
          subtitle: 'One-time {discountPrice} €',
          priceBenefit: '{benefitPercent}% cheaper',
        },
      },
    },
    wohnenPlusLight: {
      title: 'Wohnen+ Light',
      badge: '12 months free',
      headline: 'Save money with {WohnenPlusLogo} Light',
      subheadline:
        'Try Wohnen+ Light for 12 months (a trial version of Wohnen+). After that, only €1.99/month, cancel monthly.',
      benefit1: 'Save up to 15% on living services',
      benefit2: 'Free utility bill check – instead of €49',
      benefit3: 'Keep an overview of your apartment',
      benefit4: 'Included help with housing and rental questions',
      benefit5: 'Save up to 40% on electricity with no service fee for 12 months (€4.99/month thereafter)',
      disclaimer:
        '*After the 12-month free period, the membership automatically renews indefinitely at a monthly price of €1.99, cancellable at any time with 1 month notice. Our terms and conditions and cancellation policy apply. All prices incl. VAT.',
      cta: {
        buyNow: 'Buy now',
        decline: 'Decline gift',
      },
      success: {
        title: 'Congratulations, {FirstName}!',
        titleNoName: 'Congratulations!',
        subtitle: 'You can now use all the benefits of Wohnen+ Light for 12 months!',
      },
      error: {
        title: 'Technical error',
        message: "Unfortunately, that didn't work. Please try again later.",
      },
    },
  },
  livingPlusBanner: {
    description: 'With {WohnenPlusLink}, you have more than just a new home – you have security',
  },
  depositGuaranteeBanner: {
    title: 'Move in without a cash deposit with a <Indicator>Rental deposit guarantee</Indicator>',
    description: 'Stay financially flexible and use your money for moving and furniture. Your landlord is protected.',
    cta: 'Learn more',
  },
  FinancingOfferBanner: {
    description: 'What can you afford? Find the right financing option for you — free and without obligation. {Link}',
    linkText: 'Get started',
  },
  legalInsuranceHint: {
    imageAlt: 'Lightbulb',
    title: 'Tip:',
    preText: 'The ',
    buttonText: 'Neighborhood Legal Protection',
    postText: ' must be activated 3 months before use!',
  },
  membershipManagement: 'Manage Membership',
  membershipManagementUpgrade: 'Upgrade membership',
  membershipManagementCancelFreeExtension: 'Disable free renewal',
  membershipManagementCancellationPending: 'Your cancellation is being processed and will be handled shortly.',
  faq: {
    title: 'Membership FAQs',
    accordion: {
      section1: {
        premium: {
          title: 'How can I cancel my Plus membership?',
          description:
            'The booked Plus membership can be canceled at the end of the minimum contract term or monthly thereafter. You can cancel it on your own {Link}. This happens automatically for an annual or biennial Wohnen+ membership.',
        },
        livingBundle: {
          title: 'How can I cancel my Plus membership?',
          description:
            'The booked Plus membership can be canceled at the end of the minimum contract term or monthly thereafter. You can cancel it on your own {Link}. This happens automatically for an annual or biennial Wohnen+ membership.',
        },
        mieterPlus: {
          title: 'How can I cancel my Plus membership?',
          description:
            'The booked Plus membership can be canceled at the end of the minimum contract term or monthly thereafter. You can cancel it on your own {Link}.',
        },
        wohnenPlusLight: {
          title: 'How can I cancel my Wohnen+ Light membership?',
          description:
            'The booked Wohnen+ Light membership can be canceled at the end of the minimum contract term or monthly thereafter. You can cancel it on your own {Link}.',
        },
        kaeuferPlus: {
          title: 'How can I cancel my Plus membership?',
          description:
            'The booked Plus membership can be canceled at the end of the minimum contract term or monthly thereafter. You can cancel it on your own {Link}.',
        },
        linkText: 'here',
        linkTitle: 'To the Contract Overview',
      },
      section2: {
        premium: {
          title: 'Why do I have a Plus membership?',
          description:
            '<p>If you order the SCHUFA credit check, you also have the opportunity to test the Plus membership for one month. You probably selected this option during the order.</p>' +
            '{br}' +
            '<p>You can use the full range of features for the entire month and increase your chances of finding an apartment.</p>' +
            '{br}' +
            '<p>The Plus membership includes the following benefits:</p>' +
            '<ul>' +
            '<li> Chance analysis</li>' +
            '<li> Your contact requests at the top</li>' +
            '<li> Contact exclusive ads early</li>' +
            '<li> High-quality applicant portfolio</li>' +
            '<li> Rental deposit guarantee</li>' +
            '<li> SCHUFA credit check monthly</li>' +
            '<li> Proof of rent/income</li>' +
            '<li> Rental legal advice</li>' +
            '<li> Emergency locksmith service</li>' +
            '<li> Ancillary cost check</li>' +
            '</ul>',
        },
        livingBundle: {
          title: 'How can I use my Wohnen+ membership?',
          description:
            "<p>With Wohnen+ membership, you have access to many benefits that can help you in your current or future living situation. You can find an overview of your benefits under 'My Wohnen+'. Make sure to activate some of your benefits beforehand.</p>" +
            '{br}' +
            '<p>The Plus membership includes the following benefits:</p>' +
            '<ul>' +
            '<li> Membership in the Tenant Protection Club by MieterEngel</li>' +
            '<li> Emergency locksmith service</li>' +
            '<li> Review of your ancillary cost checks by MieterEngel</li>' +
            '<li> Rental legal advice</li>' +
            '<li> Storage box</li>' +
            '</ul>',
        },
        mieterPlus: {
          title: 'How can I use my Suchen+ for rent membership?',
          description:
            "Your Suchen+ for rent membership gives you many benefits to support your search for a rental property. These include a discounted SCHUFA credit check, the ImmoScout24 credit report, the application portfolio, exclusive listings, your inquiry at the top of the provider's inbox and the chance check.",
        },
        wohnenPlusLight: {
          title: 'How can I use my Wohnen+ Light membership?',
          description:
            'With Wohnen+ Light membership, you have access to selected benefits. These include the ancillary cost check, storage service, MagentaTV, and Klarwatt green electricity.',
        },
        kaeuferPlus: {
          title: 'Where can I find information about the price and duration of my membership?',
          description:
            'Information about the booked Plus membership, such as the monthly price, chosen payment method, and minimum duration, can be viewed {Link}.',
          linkText: 'here',
          linkTitle: 'To My Settings',
        },
      },
      section3: {
        premium: {
          title: 'Can I receive an invoice for my Plus membership?',
          description: '<p>Yes, you can find invoices for your membership under Account Management > My Invoices.</p>',
        },
        livingBundle: {
          title: 'Can I receive an invoice for my Plus membership?',
          description: '<p>Yes, you can find invoices for your membership under Account Management > My Invoices.</p>',
        },
        mieterPlus: {
          title: 'Can I receive an invoice for my Plus membership?',
          description: '<p>Yes, you can find invoices for your membership under Account Management > My Invoices.</p>',
        },
        wohnenPlusLight: {
          title: 'Can I receive an invoice for my Wohnen+ Light membership?',
          description: '<p>Yes, you can find invoices for your membership under Account Management > My Invoices.</p>',
        },
        kaeuferPlus: {
          title: 'Can I receive an invoice for my Plus membership?',
          description:
            'Currently, we are unable to issue an invoice for the booking of the Plus membership.{Br}{Br}Please use the booking receipts from the payment provider (PayPal, your bank, or your credit card institution) as an alternative.',
        },
      },
    },
    linkText: 'More Questions',
    linkTitle: 'Frequent Questions for Searchers',
  },
  creditsTransactionsLog: {
    link: 'View credit history',
    backButtonText: 'Back',
    title: 'Your Suchen+ Credits',
    subTitle: 'Track your transactions in the credit history',
    transactionType: {
      credit: 'Points added',
      debit: 'Points used',
    },
    eventType: {
      subscriptionPurchase: 'Granted credits on subscription purchase',
      unlockExclusiveContent: 'Unlock Exclusive Content',
      dailyDeduction: 'Daily deduction',
      dailyExtension: 'Daily extension',
      weeklyDeduction: 'Weekly deduction',
      weeklyExtension: 'Weekly extension',
      monthlyDeduction: 'Monthly deduction',
      monthlyExtension: 'Monthly extension',
    },
    noCredits: 'You have not used any credits in the last 90 days.',
    creditFetchError: 'Your data could not be loaded. Please try again later.',
  },
  customerService: {
    headline: 'More Questions?',
    text: 'If you have any questions, our customer service is here to help you:',
    eMail: 'service@immobilienscout24.de',
  },
  tenant: {
    landlord: {
      active: 'Active',
      connected: 'Landlord connected',
      contractSummary: '{date}–open-ended',
      unlimitedRentalPeriod: 'open-ended',
      monthlyRentLabel: 'Rent',
      monthlyRent: '{rent}/month',
      depositLabel: 'Deposit',
      depositTypeLabel: 'Type',
      depositGuaranteeType: 'Deposit guarantee',
      depositBankTransferType: 'Bank transfer',
      depositPledgedSavingsAccountType: 'Pledged deposit account',
      depositBankGuaranteeType: 'Private guarantee',
      depositCashType: 'Cash',
      cancelAction: 'Write termination notice',
      sectionTitle: 'My tenancy',
      sectionSubtitle: 'Everything important about your tenancy at a glance.',
    },
    depositInsurance: {
      title: 'Rental deposit guarantee+',
      active: 'Active',
      pending: 'Pending',
      pendingActivation: 'Activating',
      yearlyPaymentAmount: '{amount} / year',
      contractSummary: '{date}–open-ended',
      insurerNameLabel: 'Insurer',
      totalDepositAmountLabel: 'Guarantee amount',
      contractStartDateLabel: 'Guarantee start',
      manageCta: 'Manage',
    },
  },
};

export default en;
